export default {
  a4_paper: "A4 Paper",
  abandoned: "Abandoned",
  accepting_payment: "Accepting payment",
  accepting_payment_desc: "Turn off this if you want to stop accepting payments but keep your page visible.",
  action: "Action",
  actions: "Actions",
  activate: "Activate",
  activate_member: "Activate member",
  active_addons: "Active add-ons",
  add: "Add",
  add_address: "Add address",
  add_another: "add another",
  add_assignees: "Add Assignees",
  add_bank: "Add bank",
  add_card: "Add card",
  add_category: "Add category",
  add_discount: "Add discount",
  add_donation_amount: "Add donation amount",
  add_extra_info: "Add Extra Info",
  add_filter: "Add filter",
  add_images: "Add images",
  add_member: "Add Member",
  add_new: "Add new",
  add_new_assignees: "Add new assignees",
  add_new_cashier: "Add new cashier",
  add_new_user: "Add new user",
  add_payment_method: "Add payment method",
  add_people: "Add people",
  add_photo: "Add photo",
  add_product: "Add product",
  add_slot: "Add slot",
  add_source: "Add source",
  add_to_segment: "Add to Segment",
  add_tracking_info: "Add tracking info",
  add_variant: "Add variant",
  added: "Added",
  addon: "Add-on",
  addons: "Add-ons",
  address: "Address",
  advance_shipping_setting: "Advance Shipping Setting",
  advanced_setup: "Advanced Setup",
  after_num_days: "After {num} days",
  agent: "Agent",
  all: "All",
  allow_multiple_selection: "Allow multiple selection",
  always: "Always",
  amount: "Amount",
  amount_needed: "Amount needed",
  amount_paid: "Amount paid",
  analytics: "Analytics",
  analytics_description: "Track your marketing performance",
  announcement: "Announcement",
  apply: "Apply",
  appointments: "Appointments",
  are_you_sure_to_proceed: "Are you sure you want to proceed?",
  arrange_shipment: "Arrange shipment",
  arranged: "Arranged",
  assign: "Assign",
  assign_table: "Assign table",
  assign_table_description: "Manage tables in outlet",
  assignee_and_customer: "Assignee & customer",
  assignees: "Assignees",
  attach_invoices: "Attach Invoices",
  attach_member: "Attach member",
  attach_members: "Attach members",
  attach_products: "Attach products",
  average_transaction: "Average transaction",
  back: "Back",
  back_to_customers_page: "Back to customers page",
  back_to_tasks: "Back to Tasks",
  back_to_upload_page: "Back to upload page",
  background_color: "Background color",
  balance_amount: "Balance Amount",
  balance_due: "Balance due",
  bank: "Bank",
  bank_account: "Bank Account",
  bank_account_number: "Bank account number",
  bank_account_owner: "Bank account owner",
  batch_edit: "Batch Edit",
  batch_edit_details: "Batch edit details",
  bill_to: "Bill to",
  bills: "Bills",
  blast_sms: "Blast SMS",
  books: "Books",
  browse: "Browse",
  bundle: "Bundle",
  bundle_not_found: "Bundle not found",
  business_hours: "Business hours",
  campaign: "Campaign",
  campaign_description: "Campaign description",
  campaign_details: "Campaign details",
  campaign_details_desc: "Set title, description and goal for your campaign.",
  campaign_end_date: "Campaign end date (optional)",
  campaign_end_date_desc: "Add an end date to your page",
  campaign_title: "Campaign title",
  cancel: "Cancel",
  card: "Card",
  card_list: "Card List",
  cash_on_delivery: "Cash on Delivery",
  categories: "Categories",
  category: "category",
  category_image: "Category image",
  change: "Change",
  change_image: "Change image",
  change_phone_number_team_member: "Change phone number of your team member",
  change_photo: "Change Photo",
  change_video: "Change video",
  changes_not_saved: "Changes not saved",
  charge: "Charge",
  checkout: "Checkout",
  checkout_form: "Checkout Form",
  choose_courier: "Choose Courier",
  choose_customers: "Choose customers",
  choose_gender: "Choose gender",
  choose_layout: "Choose Layout",
  choose_new_assignee_for_task: "Choose new assignee for this task",
  choose_segment_add_customers: "Choose segment that you would like to add the customers to",
  choose_segment_that_you_want_filter: "Choose the segment(s) that you want to filter",
  choose_your_assigness: "Choose your assigness",
  classic: "Classic",
  clear: "Clear",
  clear_all_filters: "Clear all filters",
  clear_filters: "Clear filters",
  clear_selection: "Clear selection",
  click_confirm_to_proceed: "Click 'Confirm' to proceed.",
  clicks: "Clicks",
  close: "Close",
  closed: "Closed",
  collect: "Collect",
  collect_extra_info: "Collect extra info",
  commission: "Commission",
  commission_list: "Commission List",
  commissions: "Commissions",
  company: "Company",
  company_details: "Company Details",
  company_logo: "Company logo",
  completed: "Completed",
  confirm: "Confirm",
  confirmation_code: "Confirmation Code",
  connect: "Connect",
  connect_website: "Connect website",
  contact: "Contact",
  continue: "Continue",
  copy: "Copy",
  copy_custom_link: "Copy custom link",
  copy_link: "Copy link",
  copy_paste_content: "Copy & paste the following content onto your website",
  copy_short_link: "Copy short link",
  copy_url: "Copy URL",
  coupon: "Coupon",
  coupon_code: "Coupon code",
  coupons: "Coupons",
  courier: "Courier",
  cover_photo: "Cover photo",
  cover_photo_desc: "Add photo or video to your donation page",
  create: "Create",
  create_account: "Create Account",
  create_form: "Create New Form",
  create_new_category: "Create New Category",
  create_new_task: "Create new task",
  create_product_notes: "Create product notes",
  create_segment: "Create segment",
  create_task: "Create task",
  created: "Created",
  created_on: "Created on",
  credit_history: "Credit History",
  custom: "Custom",
  custom_dates: "Custom dates",
  custom_link: "Custom Link",
  customer: "Customer",
  customer_actions: "Customer actions",
  customer_info: "Customer Info",
  customer_message: "Customer message",
  customer_name: "Customer name",
  customer_selection: "Customer selection",
  customers: "Customers",
  customers_engaged: "Customers engaged",
  customers_note: "Customer’s note",
  customers_selected_from_list: "customers selected from customer list",
  customize_column: "Customize Column",
  customize_message: "Customize message",
  data_collection: "Data collection",
  database: "Database",
  date: "Date",
  date_range: "Date range",
  date_selection: "Date selection",
  date_selection_mode: "Date Selection Mode",
  day: "Day",
  default_payment_frequency: "Default payment frequency",
  default_tax_rate: "Default tax rate",
  delete: "Delete",
  delete_category: "Delete category",
  delete_customer: "Delete customer",
  delete_form: "Delete Form",
  delete_form_confirmation: "Are you sure you want to delete this form? This form will be deleted permanently.",
  delete_image: "Delete image",
  delete_image_confirmation: "Are you sure you want to delete this image? This image will be deleted permanently.",
  delete_item: "Delete item",
  delete_member: "Delete member",
  delete_page: "Delete page",
  delete_product: "Delete Product",
  delete_product_confirmation: "Are you sure you want to delete this item? This item will be deleted permanently.",
  delete_segment: "Delete segment",
  delete_segment_confirmation: "Are you sure you want to delete these segments?",
  delete_selected: "Delete selected",
  delete_task: "Delete task",
  delete_task_confirmation_1: "Are you sure you want to delete this task?",
  delete_task_confirmation_2: "This task will be deleted immediately. You can't undo this action.",
  delivered: "Delivered",
  delivery_charge: "Delivery Charge",
  delivery_day: "Delivery day",
  delivery_platform: "Delivery Platform",
  description: "Description",
  description_optional: "Description (Optional)",
  details: "Details",
  dialog_please_pay: "Please pay to proceed",
  dialog_please_pay_text: "You will be redirected to a payment page after clicking 'Pay Now' button. Please close that page after payment is completed.",
  difficult_to_learn: "Difficult to learn.",
  disable_checkout: "Disable checkout",
  disable_payment: "Disable payment",
  disabled: "Disabled",
  discard_changes: "Discard changes",
  discount: "Discount",
  domain_verifications: "Domain Verifications",
  donation_amounts: "Donation amounts",
  donation_amounts_desc: "Set the donation amounts on your campaign.",
  donation_forms: "Donation Forms",
  donation_product_limit_reached: "Limit reached. You can only add up to 7 different custom amounts.",
  done: "Done",
  donor: "Donor",
  donors: "Donors",
  download: "Download",
  download_as_pdf: "Download as PDF",
  download_as_png: "Download as PNG",
  drop_off: "Drop-off",
  due_by: "Due by",
  due_date: "Due date",
  duplicate: "Duplicate",
  duplicate_form: "Duplicate form",
  duplicate_product: "Duplicate Product",
  edit: "Edit",
  edit_address: "Edit address",
  edit_category: "Edit Category",
  edit_customer_info: "Edit customer info",
  edit_details: "Edit Details",
  edit_extra_info: "Edit Extra Info",
  edit_member: "Edit member",
  edit_message_template: "Edit message template",
  edit_new_cashier: "Edit new cashier",
  edit_order: "Edit order",
  edit_subscription: "Edit Subscription",
  edit_variant: "Edit variant",
  edit_weight: "Edit weight",
  email: "Email",
  email_address: "Email Address",
  embed: "Embed",
  embed_as: "Embed as",
  embed_form: "Embed form",
  embed_in_website: "Embed in your website",
  embed_video: "Embed video",
  enable_business_hour: "Enable business hour",
  engaged_customers: "Engaged customers",
  engagement_rate: "Engagement rate",
  enter_email_new_member: "Enter email of the new team member",
  enter_individual_value: "Enter individual value",
  enter_segment_name_and_description: "Enter your segment name and description below.",
  enter_value: "Enter value",
  error: "Error",
  error_message: {
    add_product_before_addons: "Please add the product first before managing add-ons",
    add_product_before_image: "Please add the product first before adding more image",
    amount_is_required: "Amount is required",
    category_is_required: "Category is required",
    check_email_logging_number: "Check your email or try logging in with your number",
    check_number_logging_email: "Check your number or try logging in with your email",
    checkout_payment_field_required: "Checkout / Payment field is required",
    copy_address_failed: "Copy address failed. Please try again",
    date_is_required: "Date is required",
    delete_product_remove_variants: "Delete product to remove all variants",
    discount_price_not_bigger: "Discount price must not bigger than product price",
    enter_email_first: "Enter e-mail address first",
    enter_new_email: "Enter new e-mail address first",
    enter_new_phone: "Enter new phone number first",
    enter_phone_number: "Enter phone number first",
    error_adding_card: "Error adding card. Kindly contact your debit/credit card provider (Bigpay, Maybank, CIMB Bank, etc) for further assistance. Or try using another card",
    error_occured: "Error occured. Please try again later.",
    exceeded_form_count: "Exceeded total allowed form count",
    exceeded_member_count: "Exceeded total allowed member count",
    form_name_required: "Form name is required",
    image_file_is_required: "Image file is required",
    image_invalid: "This image is invalid",
    invalid_amount: "Invalid amount",
    invalid_code: "Invalid code. Please try again.",
    invalid_confirmation_code: "Invalid confirmation code",
    invalid_email_or_password: "Invalid email or password",
    invalid_email_phone_password: "Invalid email/phone or password",
    invalid_plan: "Invalid plan",
    invalid_postcode_number: "Invalid postcode number",
    invalid_tac: "Invalid TAC. Please try again.",
    invalid_tac_number: "Invalid TAC number",
    invoice_is_required: "Invoice is required",
    item_is_required: "Item is required",
    max_hundred_orders: "Maximum 100 orders in single action",
    max_images_ten: "Maximum number of images is 10 per upload",
    max_orders_in_export: "Maximum {count} orders in single export",
    no_account_associated_email: "No user account associated with given email",
    no_account_associated_phone: "No user account associated with given phone",
    no_account_email_address: "No account found for entered email address",
    no_account_found_phone_number: "No account found for entered phone number",
    no_account_phone_number: "No account for given phone number",
    no_image_found: "No image found.",
    no_options_selected: "No options selected",
    no_order_export: "No order to export",
    no_product_selected: "No product selected",
    no_shipping_method: "No shipping method selected",
    no_user_google_id: "No user exists for given Google ID. Please proceed to sign up.",
    not_enough_stock: "Not enough stock available. Change your order quantity or consult with seller.",
    page_content_not_empty: "Page content must not empty",
    parcel_label_not_available: "Parcel label is not available yet",
    password_not_match: "Password not match",
    payment_method_required: "Payment method is required",
    please_add_product_first: "Please add the product first before adding more image",
    please_choose_courier: "Please choose a courier",
    please_enable_at_setup: "Please enable this first at Setup -> Shipping & Delivery",
    please_enter_max_weight: "Please enter max weight correctly",
    please_enter_valid_domain: "Please enter a valid domain name.",
    please_fill_all_items: "Please fill all items",
    please_fill_company_address: "Please fill in company address in Settings page first",
    please_fill_email_phone: "Please fill in your email or phone number",
    please_fill_out_all: "Please fill out all fields",
    please_fill_out_all_required: "Please fill out all required fields",
    please_publish_this_form: "Please publish this form before sharing.",
    please_select_courier: "Please select one or more courier",
    please_select_payment_method: "Please select payment method",
    please_select_required_column: "Please select required colum",
    please_setup_bundle_items: "Please setup your bundle items",
    please_setup_your_variant: "Please setup your variant first",
    reminder_channel_required: "Reminder channel is required",
    segment_update_unsuccessful: "Segment update unsuccessful",
    select_one_order: "Select at least 1 order to continue",
    select_one_order_export: "Select at least 1 order to export",
    select_one_order_ship: "Select at least 1 order to ship",
    select_only_overdue: "Select only Overdue or Unsent.",
    seller_required: "Seller is required",
    sorry_company_subsidised: "Sorry, you already have another company subsidised",
    sorry_no_open_seats: "Sorry, no more open seats for this program",
    sorry_not_eligible: "Sorry, you are not eligible for this program",
    sorry_this_offer_ended: "Sorry, this offer already ended",
    this_email_must_verified: "This e-mail address must be verified to use it for sign in. Please sign in with phone number.",
    this_method_not_supported: "This method is not supported",
    unable_to_add_customer_segment: "Unable to add customer to segment",
    unable_to_add_new_assignee: "Unable to add new assignee",
    unable_to_change_segment_description: "Unable to change segment description",
    unable_to_change_segment_title: "Unable to change segment title.",
    unable_to_change_task_name: "Unable to change task name",
    unable_to_complete_request: "Unable to complete your request. Please try again later",
    unable_to_load_data: "Unable to load data",
    please_try_again: "Please try again",
    unable_to_complete_request_contact: "Unable to complete your request. Please contact our support team.",
    unable_to_make_payment: "Unable to make payment. Please try again later",
    unable_to_create_segment: "Unable to create segment",
    unable_to_create_task: "Unable to create task",
    unable_to_delete_customer: "Unable to delete customer",
    unable_to_import_csv: "Unable to import CSV",
    unable_to_match_data: "Unable to match your data. Please try again later",
    unable_to_remove_assignee: "Unable to remove assignee",
    unable_to_remove_card: "Unable to remove card. Card may currently tied to active subscription.",
    unable_to_remove_customer: "Unable to remove customer",
    unable_to_remove_segment: "Unable to remove segment",
    unable_to_remove_task: "Unable to remove task",
    unable_to_resume_update: "Unable to resume update. Please contact support.",
    unable_to_send_confirmation: "Unable to send confirmation code, check e-mail address is correct",
    unable_to_send_tac: "Unable to send TAC, check phone number is correct",
    unable_to_stop_update: "Unable to stop update. Please contact support.",
    unable_to_submit_order: "Unable to submit your order. Please try again later",
    unable_to_subscribe_card: "Unable to subscribe. Please try different card or contact our support team.",
    unable_to_subscribe_method: "Unable to subscribe. Please try different method or contact our support team.",
    unable_to_subscribe_try_again_contact_us: "Unable to subscribe. Please try again or contact our support team.",
    unable_to_update_custom_link: "Unable to update custom link. Please try other name or contact our support",
    unable_to_update_order: "Unable to update order settings. Please try again later",
    unable_to_update_products: "Unable to update products. Please contact support.",
    unable_to_update_template: "Unable to update template",
    unable_to_upgrade: "Unable to upgrade. Please contact our support team.",
    unable_to_upload_document: "Unable to upload your document. Please try again later",
    unable_to_upload_image: "Unable to upload image. Please try again later",
    url_invalid: "This url is invalid",
    user_accepted_invitation: "This user is already accepted your invitation",
    error_move_item: "Error moving {item}",
    call_patient_in_first: "Please call the in the patient first",
    file_reached_limit: "File reached limit",
    create_item_first: "Please create {item} first",
  },
  error_unable_to_subscribe: "Unable to subscribe. Please try different card or contact our support team.",
  error_unable_to_upgrade: "Unable to upgrade. Please contact our support team.",
  estimated_price: "Estimated price",
  event_id: "Event id",
  every_record_with_error: "Every record with error will not be included in your segment.",
  example: "Example",
  exit: "Exit",
  expected: "Expected",
  expense: "Expense",
  expiry: "Expiry",
  export: "Export",
  extra_info: "Extra info",
  fees_and_tips: "Fees & tips",
  fees_and_tips_desc: "Configure the fees & tips on your campaign",
  fill_all_field_below: "Fill in all the field below",
  filter: "Filter",
  filter_age: "Filter Age",
  filter_age_with_value: "Filter age with value",
  filter_applied: "Filter applied",
  filter_chart: "Filter chart",
  filter_customer_that_are_created: "Filter customers that are created",
  filter_customer_with_gender: "Filter customer with gender of",
  filter_data_created_on: "Filter date (created on)",
  filter_gender: "Filter gender",
  filter_order_count: "Filter order count",
  filter_order_count_with_value: "Filter order count with value",
  filter_segment: "Filter segment",
  filter_total_contribution: "Filter total contribution",
  filters: "Filters",
  finish: "Finish",
  finish_up_segment: "Finish up segment",
  floating_button: "Floating Button",
  follow_up: "Follow-up",
  footer: "Footer",
  for_optimized_design: "For optimized design, keep your description within 160 characters",
  form: "Form",
  form_example: "Form example",
  form_name: "Form Name",
  form_url: "Form URL",
  format: "Format",
  forms_not_found: "Forms not found or empty",
  free_shipping: "Free Shipping",
  from: "From",
  from_yesterday: "from yesterday",
  fulfilment_method: "Fulfilment method",
  fundraiser: "Fundraiser",
  fundraisers: "Fundraisers",
  gateway: "Gateway",
  general: "General",
  generate: "Generate",
  generate_qr_code: "Generate QR code",
  generate_qr_code_description: "Create and manage QR codes for each table.",
  generating_share_url: "Generating share url",
  go_to_link: "Go to link",
  goal_desc: "Add a donation bar to your page",
  goal_optional: "Goal (optional)",
  got_it: "Got it",
  hardware_settings: "Hardware settings",
  hardware_settings_description: "Hardware connections to POS",
  has_inventory: "Has inventory",
  header: "Header",
  help_center: "Help Center",
  hidden: "Hidden",
  hide_soldout_product: "Hide soldout products",
  history_of_payment: "History of payment",
  holidays: "Holidays",
  home: "Home",
  iframe: "iFrame",
  images: "Images",
  in_stock: "In stock",
  include: "Include",
  include_addons: "Include add-ons",
  include_product_image: "Include product image",
  include_product_video: "Include product video",
  include_variants: "Include variants",
  income: "Income",
  income_invoice: "income invoice",
  info_message: {
    confirmation_code_sent_to: "Confirmation code sent to {text}",
    domain_request_sent: "Your domain request has been sent",
    tac_sent_to: "TAC sent to {text}",
  },
  insert_field: "Insert Field",
  inventory: "Inventory",
  invite: "Invite",
  invite_member: "Invite Member",
  invite_new_admin: "Invite new admin",
  invite_new_member: "Invite new member",
  invited_list: "Invited List",
  invoice: "Invoice",
  invoice_link: "Invoice Link",
  item: "Item",
  item_list: "Item list",
  items: "Items",
  items_ordered: "Items ordered",
  keep_working: "Keep working",
  label: "Label",
  last_updated_on: "Last updated on",
  layouts: "Layouts",
  lead: "Lead",
  leads: "Leads",
  learn_more: "Learn More",
  learn_more_about: "Learn more about",
  leave_feedback: "Leave Feedback",
  leave_us_message: "Leave us a message",
  left_in_stock: "left in stock",
  list_view: "List view",
  list_view_desc: "A simplified page view of your Order",
  load_more: "Load more",
  loading: "Loading",
  local_delivery: "Local Delivery",
  log_in: "Log In",
  looking_good: "Looking good!",
  low_balance: "Low balance",
  manage: "Manage",
  manage_addons: "manage add-ons",
  manage_campaign: "Manage campaign",
  manage_forms: "Manage forms",
  manage_inventory: "manage inventory",
  manage_member: "Manage members",
  manage_shipping_zones: "Manage Shipping Zones",
  mark_as_paid: "Mark as paid",
  max_image_filesize: "Max filesize 10 MB",
  max_video_filesize: "Max filesize 30 MB",
  maybe_later: "Maybe Later",
  members_not_found: "Members not found or empty",
  menu: "Menu",
  menu_categories: "Menu Categories",
  message: "Message",
  message_preview: "Message preview",
  message_template: "Message Template",
  meta_description: "Meta Description (SEO)",
  meta_title: "Meta Title (SEO)",
  method: "Method",
  min_order_amount: "Minimum Order Amount",
  missing_features: "Missing features",
  month: "month",
  monthly: "monthly",
  more: "More",
  more_details: "More details",
  multiple_date: "Multiple Dates",
  name: "Name",
  name_on_card: "Name on card",
  new: "New",
  new_campaign: "New campaign",
  new_features: "New Features",
  new_segment: "New Segment",
  new_task: "New task",
  new_user: "New User",
  newest: "Newest",
  next: "Next",
  no: "No",
  no_categories_yet: "No categories yet",
  no_change_subscription: "No changes in subscription",
  no_customer_available: "No customer available",
  no_customer_found: "No customer found",
  no_file_selected: "No file selected",
  no_inventory: "No inventory",
  no_item_found: "No item found in database or empty",
  no_limit: "No limit",
  no_list_available: "No list available",
  no_members_available: "No members available",
  no_orders_adjust_filter: "Try adjusting your filter selections.",
  no_orders_found: "No orders found.",
  no_record_error_found: "No record error found",
  no_segments_available: "No segments available",
  no_tasks_available: "No tasks available",
  not_arranged_yet: "Not Arranged yet",
  note: "Note",
  notifications: "Notifications",
  now: "Now",
  number_of_table: "Number of table",
  offers: "Offers",
  oldest: "Oldest",
  on_demand: "On-Demand",
  one_month: "1 Month",
  one_week: "1 Week",
  one_year: "One Year",
  only_count_left_in_stock: "Only {qty} left in stock",
  only_when_low: "Only when low",
  open: "Open",
  or: "Or",
  order: "Order",
  order_created: "Order created",
  order_delivered: "Order delivered",
  order_id: "Order ID",
  order_items: "Order items",
  order_limit: "Order limit",
  order_scheduled: "Order scheduled",
  order_settings: "Order Settings",
  order_shipped: "Order shipped",
  orders: "Orders",
  other: "Others",
  overdue: "Overdue",
  packing_slips: "Packing Slips",
  page_views: "Page views",
  pages: "Pages",
  pass_service_fee: "Pass service fee",
  past_7_days: "Past 7 days",
  paste_video_url: "Paste video url down below",
  paste_video_url_desc: "Embed video from Youtube, Facebook, Twitch & Vimeo only",
  pay_at_shop: "Pay at shop",
  pay_before: "Pay before",
  pay_now: "Pay now",
  payment: "Payment",
  payment_and_checkout: "Payment & checkout",
  payment_and_checkout_desc: "Configure the payment and checkout options for your campaign",
  payment_gateway_details: "Activate Credit / Debit Card and FPX (Online Banking) Payment",
  payment_method: "Payment method",
  payment_options: "Payment options",
  payment_options_description: "Manage payment options for table ordering.",
  payment_settings: "Payment settings",
  payment_settings_description: "Manage POS payment settings ",
  payment_status: "payment status",
  payment_type: "Payment type",
  payments: "Payments",
  payout_amount: "Payout amount",
  payouts: "Payouts",
  pending_invites: "pending invites",
  pending_payment: "Pending payment",
  phone: "Phone",
  phone_number: "Phone number",
  pick: "Pick",
  pick_color: "pick color",
  pick_list: "Pick List",
  pick_up: "Pick up",
  pickup: "Pickup",
  please_complete_payment_before: "Please complete payment before",
  please_select_delivery_date: "Please select delivery date",
  pos_setup: "POS Setup",
  pos_user_access: "POS User Access",
  powered_by_yezza: "Powered by Yezza",
  preferred: "Preferred",
  preview: "Preview",
  price: "Price",
  print: "Print",
  print_qr_code: "Print QR Code",
  processing: "Processing",
  product: "Product",
  product_categories: "Product Categories",
  product_image: "Product Image",
  product_limited_stock: "This product has limited stock",
  product_name: "Product Name",
  product_notes: "Product notes",
  product_variant: "Product Variant",
  product_video: "Product Video",
  product_weight_missing: "Product weight missing",
  products: "Products",
  products_not_found: "Products not found or empty",
  products_sold: "Products sold",
  profit: "Profit",
  profit_loss: "Profit & Loss",
  promo_banner: "Promo banner",
  promo_description: "Promo description",
  promo_discount: "Promo Discount",
  publish_banner: "Publish banner",
  qr_code: "QR Code",
  qr_code_desc: "Print and scan this QR Code to be linked directly to your {item}.",
  qty: "Qty",
  quick_action: "Quick action",
  quick_links: "Quick links",
  rank: "Rank",
  rate: "Rate",
  ready: "Ready",
  rearrange: "Rearrange",
  receipt: "Receipt",
  receipt_preview: "Receipt preview",
  receipt_template: "Receipt template",
  receipt_template_description: "Customize information displayed on receipts",
  recipient: "Recipient",
  recipient_address: "Recipient address",
  recommended_image_size: "Recommended image size 960x960 px",
  recommended_logo_size: "Recommended image size 640x160 px (aspect ratio 4:1)",
  recommended_video_size: "Recommended video aspect ratio 1:1",
  record: "Record",
  record_date: "record date",
  record_error: "record error",
  records_were_found: "records were found",
  ref_id: "Ref ID",
  reference_id: "Reference ID",
  register: "Register",
  reload: "Reload",
  remarks: "Remarks",
  reminder: "reminder",
  reminders: "Reminders",
  remove: "Remove",
  remove_assignee: "Remove assignee",
  remove_assignee_confirmation_1: "Are you sure you want to delete this assignee?",
  remove_assignee_confirmation_2: "This assignee will be removed immediately. You can’t undo this action.",
  remove_card: "Remove card",
  remove_customer_segment: "Remove customer from segment",
  remove_customer_segment_confirmation_1: "Are you sure you want to remove these customers from this segment?",
  remove_customer_segment_confirmation_2: "This person will be removed immediately. You can’t undo this action.",
  remove_field: "Remove field",
  remove_invites: "Remove invites",
  remove_invites_confirmation_1: "Are you sure you want to remove the person from invitation list?",
  remove_invites_confirmation_2: "This person will be removed immediately. You can’t undo this action.",
  remove_member: "Remove member",
  remove_member_confirmation_1: "Are you sure you want to remove the member from your team?",
  remove_member_confirmation_2: "This person will be removed immediately. You can’t undo this action.",
  remove_selected: "Remove selected",
  remove_variants: "Remove variants",
  remove_video: "Remove Video",
  renew_subscription: "Renew Subscription",
  repeat_this_order: "Repeat this order",
  reports: "Reports",
  require_min_donation_amount: "Require a minimum donation amount",
  required: "Required",
  resend: "Resend",
  reset: "Reset",
  reset_to_default: "Reset to default",
  restaurant: "Restaurant",
  retry: "Retry",
  return_to_subscription: "Return to subscription",
  reupload_csv: "Reupload CSV",
  role: "Role",
  sales: "Sales",
  sales_date: "Sales Date",
  sales_page: "Sales page",
  sales_pages: "Sales Pages",
  sales_team: "Sales Team",
  save: "Save",
  save_and_continue: "Save & continue",
  save_changes: "Save changes",
  save_variants: "Save variants",
  scheduled_date_time: "Scheduled date & time",
  scheduling: "Scheduling",
  search: "Search",
  search_bundle: "Search bundle",
  search_category: "Search category",
  search_customer: "Search customer",
  search_donors: "Search donors",
  search_engine_optimization: "Search Engine Optimization (SEO)",
  search_engine_optimization_desc: "SEO options control what your donors see when viewing this item in a search engine. You can fill these out yourself. Or, if you prefer, we'll use your default item information.",
  search_form: "Search form",
  search_fundraiser: "Search fundraiser",
  search_member: "Search member",
  search_order: "Search order",
  search_product: "Search product",
  search_segments: "Search segments",
  search_tasks: "Search tasks",
  segment_detail: "Segment detail",
  segments: "Segments",
  select: "Select",
  select_bank: "Select bank",
  select_coupon: "Select Coupon",
  select_new: "Select new",
  select_paper_size: "Select Paper Size",
  select_plan: "Select plan",
  select_product: "Select product",
  select_shipping_method: "Select Shipping Method",
  select_shipping_zones: "Select shipping zones",
  select_source: "Select Source",
  selected_courier_unavailable: "Selected courier unavailable",
  selected_customers_will_added_to_segment: "Any selected customers will automatically added to segment",
  selected_option: "Selected option",
  self_pickup: "Self-Pickup",
  sellers: "Sellers",
  send: "Send",
  send_fb_test_event: "Send facebook test event",
  send_message: "Send Message",
  send_message_placeholder: "This would be the input for long text. It can contain longer text. When the input exceeds the vertical size of this field, scrolling mech will be enabled.",
  send_message_to_customer: "Send message to your customer",
  send_message_to_customer_desc: "Write your message to be sent to customer below",
  send_reminder: "Send reminder",
  send_sms: "Send SMS",
  send_to_customer: "Send to Customer",
  sent_to: "Sent to",
  seo_description: "SEO Description",
  seo_description_desc: "The linked description users see in search results",
  seo_photo: "SEO Photo",
  seo_photo_desc: "This is the thumbnail will be used when sharing on social media",
  seo_title: "SEO Title",
  seo_title_desc: "The linked title users see in search results",
  service: "Service",
  service_fee: "Service Fee",
  set_all_height_to: "Set all height to",
  set_all_length_to: "Set all length to",
  set_all_price_to: "Set all price to",
  set_all_stock_to: "Set all stock to",
  set_all_weight_to: "Set all weight to",
  set_all_width_to: "Set all width to",
  set_amount: "Set Amount",
  set_minimum_amount: "Set minimum amount",
  set_product_weight: "Set product weight",
  set_shipping_date: "Set Shipping Date",
  set_shipping_time: "Set Shipping Time",
  set_variant_details: "Set variant details",
  settings: "Settings",
  setup: "Setup",
  setup_account: "setup account",
  setup_number_of_tables: "Setup number of tables",
  share: "Share",
  share_invoice: "Share Invoice",
  share_invoice_link_by: "Share invoice link by",
  share_to_whatsapp: "Share to WhatsApp",
  share_url_by: "Share url by",
  share_your_agent_links: "Share your agent links",
  sharing: "Sharing",
  ship_to: "Ship to",
  ship_to_this_address: "Ship to this address",
  shipping: "Shipping",
  shipping_address: "Shipping address",
  shipping_and_delivery: "Shipping & Delivery",
  shipping_date: "Shipping date",
  shipping_error: "Shipping error",
  shipping_method: "Shipping Method",
  shipping_tab: "Shipping",
  shipping_time: "Shipping time",
  shipping_zone: "Shipping Zone",
  show: "Show",
  show_an_other_option: "Show an 'Other' option to allow donors to enter custom amount the want to donate",
  show_customers: "Show customers",
  show_donors: "Show donors",
  show_fundraiser: "Show fundraiser",
  show_less: "Show less",
  show_more: "Show more",
  show_segments: "Show segments",
  show_tasks: "Show tasks",
  sign_in: "Sign In",
  sign_out: "Sign Out",
  single_date: "Single date",
  six_digit_code: "6 digit Code",
  small_receipt: "Small Receipt",
  sms_blast_report: "SMS blast report",
  sold_out: "Sold out",
  sort: "Sort",
  sort_products: "Sort products",
  source: "Source",
  start: "Start",
  start_form_creation: "Start Creating Your WhatsApp Form. Share, Click, Pay.",
  start_sending_message: "start sending message",
  status: "Status",
  stock: "Stock",
  stock_up_soon: "Stock up soon",
  store_pickup: "Store Pickup",
  story: "Story",
  story_desc: "Add a story to your campaign. This appears directly below the title and cover photo.",
  submit: "Submit",
  submit_ideas: "Submit Ideas",
  subscribe_now: "Subscribe now",
  subscribed_addons: "Subscribed add-ons",
  subscription: "Subscription",
  subtotal: "Subtotal",
  success: "Success",
  success_message: {
    address_copied_to_clipboard: "Address copied to your clipboard",
    address_updated: "Address updated",
    assignee_removed_successfully: "Assignee removed successfully",
    business_hour_updated: "Business hour updated",
    card_successfully_added: "Card successfully added",
    card_successfully_deleted: "Card successfully deleted",
    category_changed_draft: "Category changed to draft",
    category_created: "Category created",
    category_published_successfully: "Category published successfully",
    category_updated: "Category updated",
    code_copied_to_clipboard: "Code copied to your clipboard",
    commissions_processed: "Commissions processed",
    content_copied_to_clipboard: "Content copied to your clipboard",
    coupon_added: "Coupon added",
    coupon_code_applied: "Coupon code applied",
    coupon_code_removed: "Coupon code removed",
    coupon_edited: "Coupon edited",
    customer_added_segment_successfully: "Customer added to segment successfully",
    customer_created: "Customer created",
    customer_edited: "Customer edited",
    customers_deleted_successfully: "Customers deleted successfully",
    campaign_deleted_successfully: "Campaign deleted successfully",
    donors_deleted_successfully: "Donors deleted successfully",
    customers_successfully_removed_from_segment: "{count} customers have been successfully removed from this segment",
    email_successfully_updated: "E-mail address successfully updated",
    email_successfully_verified: "Email successfully verified",
    expense_recorded_successfully: "Expense recorded successfully",
    form_created: "Form created",
    form_duplicated: "Form duplicated",
    form_updated: "Form updated",
    image_added: "Image added",
    image_updated: "Image updated.",
    income_edited: "Income edited",
    income_recorded_successfully: "Income recorded successfully",
    invitation_deleted: "Invitation deleted",
    invitation_sent: "Invitation sent",
    invitation_sent_successfully: "Invitation sent successfully",
    link_copied_to_clipboard: "Link copied to your clipboard",
    mall_edited: "Mall edited",
    manage_order_disabled: "Manage order disabled",
    member_added: "Member added",
    member_edited: "Member edited",
    member_remove_successfully: "Member removed successfully",
    member_successfully_deleted: "Member successfully deleted.",
    member_tier_updated: "Member tier updated",
    minimum_order_updated: "Minimum order amount updated",
    new_assignee_added_successfully: "New assignee added successfully",
    new_cashier_created: "New cashier was successfully created",
    one_page_checkout_updated: "One-page checkout updated",
    order_cancelled: "Order cancelled",
    page_created: "Page created",
    page_updated: "Page updated",
    payment_edited: "Payment edited",
    payment_successful: "Payment Successful",
    payout_archived: "Payout archived",
    payout_updated: "Payout updated",
    phone_successfully_updated: "Phone number successfully updated",
    product_added: "Product added",
    product_commissions_updated: "Product commissions updated",
    product_edited: "Product edited",
    product_successfully_imported: "Product successfully imported",
    product_updated: "Product updated",
    profile_updated: "Profile updated",
    promo_banner_updated: "Promo banner updated",
    reload_successful: "Reload successful",
    reminder_sent: "Reminder sent",
    request_under_processing: "Your request is now under processing",
    response_recorded: "Response has been recorded. Thank you!",
    sales_popup_updated: "Sales pop-up updated",
    segment_created_successfully: "Segment created successfully",
    segment_description_changed_successfully: "Segment description changed successfully",
    segment_not_shown_at_tab: "Segment will not be shown at extension tab",
    segment_remove_successfully: "Segment remove successfully",
    segment_shown_at_tab: "Segment will be shown at extension tab",
    segment_title_changed_successfully: "Segment title changed successfully",
    segment_update_successful: "Segment update successfully",
    store_edited: "Store edited",
    successfully_saved_bank_account: "Successfully saved company bank account information",
    successfully_updated: "Successfully updated",
    switched_back_old_checkout: "Switched back to old checkout",
    task_created_successfully: "Task created successfully",
    task_name_changed_successfully: "Task name changed successfully",
    task_remove_successfully: "Task remove successfully",
    template_updated_successfully: "Template updated successfully",
    tracking_link_copied_clipboard: "Tracking link copied to your clipboard",
    tracking_number_copied_clipboard: "Tracking number copied to your clipboard",
    vendor_created: "Vendor created",
    vendor_edited: "Vendor edited",
    visibility_updated: "Visibility updated",
    webhook_integration_success: "Webhook integration successfully updated",
    your_concern_reported: "Your concern has been reported for investigation.",
    your_idea_recorded: "Your idea has been recorded. Thank you!",
    zone_successfully_updated: "Zone was successfully updated.",
    provider_deleted_successfully: "Provider deleted successfully",
    service_deleted_successfully: "Service deleted successfully",
    field_deleted_successfully: "Field deleted successfully",
    update_successful: "Update successful",
    delete_successful: "Delete successful",
    category_deleted_successfully: "Category deleted successfully",
    service_assigned_successfully: "Service assigned to category successfully",
    service_reassigned_successfully: "Service reassigned successfully",
    service_removed_successfully: "Service removed successfully",
    photo_deleted_successfully: "Photo deleted successfully",
    item_copied_to_clipboard: "{item} copied to your clipboard",
    new_api_key_generated: "New API Key has been generated",
    csv_imported_successfully: "CSV imported successfully",
    medication_added_successfully: "Medication added successfully",
    tax_added_successfully: "Tax added successfully",
    successfully_send_to_printer: "Successfully sent to printer",
    preset_updated_successfully: "Preset updated successfully",
    panel_created: "Panel created successfully",
    panel_updated: "Panel updated successfully"
  },
  switch_company: "Switch company",
  sync_products: "Sync Products",
  synced: "Synced",
  table_available: "Table Available",
  table_ordering: "Table Ordering",
  tac: "TAC",
  task_detail: "Task detail",
  task_not_found: "Task not found",
  tasks: "Tasks",
  tax: "Tax",
  test: "Test",
  test_event_code: "Test event code",
  text_color: "Text color",
  thank_you_message: "Thank you message",
  thank_you_message_desc: "Write a custom thank you message that will appear on success page after payment.",
  this_computer_generated_invoice: "This is a computer generated invoice. No signature required.",
  this_computer_generated_receipt: "This is a computer generated receipt. No signature required.",
  this_is_computer_generated: "This is computer generated document. No signature required.",
  this_month: "This month",
  this_person_received_invitation_email: "This person will received invitation through their email",
  this_week: "This week",
  this_year: "This year",
  three_month: "3 Months",
  title: "Title",
  today: "Today",
  too_slow: "Too slow.",
  total: "Total",
  total_donors: "Total donors",
  total_leads: "Total leads",
  total_sales: "Total sales",
  total_views: "Total views ",
  total_weight: "Total weight",
  track: "Track",
  track_your_parcel: "Track your parcel",
  tracking_info: "Tracking info",
  tracking_number: "Tracking number",
  transaction_details: "transaction details",
  transaction_history: "Transaction history",
  transactions: "Transactions",
  type_in_segment_name: "Type in segment name",
  unpaid_invoices: "Unpaid Invoices",
  until: "Until",
  update: "Update",
  update_bank: "Update Bank",
  update_status: "Update Status",
  update_tracking_info: "Update tracking info",
  update_weight: "Update weight",
  upload: "Upload",
  upload_and_continue: "Upload and continue",
  upload_image: "Upload image",
  upload_photo: "Upload photo",
  upload_photo_10_mb: "Upload photo. (Max size 10MB)",
  user_settings: "User settings",
  user_settings_description: "Manage user roles, POS access",
  username: "Username",
  users: "Users",
  value_must_be_in_number: "Value must be in number",
  variant_name: "Variant name",
  variant_type: "Variant type",
  variants: "Variants",
  verify: "verify",
  video_url: "Video URL",
  view_all_addons: "View all add-ons",
  view_all_variants: "View all variants",
  view_form: "View form",
  view_history: "View history",
  view_invoice: "View invoice",
  view_job_list: "View job list",
  view_page: "View page",
  view_receipt: "View receipt",
  views: "Views",
  wallet: "Wallet",
  webhook: "Webhook",
  webhook_integration: "Webhook Integration",
  week: "Week",
  weight: "Weight",
  weight_kg: "Weight (KG)",
  what_look_like: "What does this look like?",
  whatsapp_forms: "WhatsApp Forms",
  whos_selling: "Who’s selling",
  within_num_days: "Within {num} days",
  year: "year",
  yes: "Yes",
  yesterday: "Yesterday",
  yesterday_at: "Yesterday at",
  yezza_store: "Yezza Store",
  yezza_store_features: "Yezza Store Features",
  you_are_currently_using: "You are currently using",
  you_can_insert_field_into: "You can insert field into your template",
  your_language: "Your language",
  zone: "Zone",
  confirmation_send_message_donor: "Are you sure you want to send this message to your donors?",
  you_cant_undo_send_message: "You can’t undo this action once you sent the message. Click “Send” to proceed.",
  event_name: "Event name",
  email_blast_report: "Email blast report",
  performance: "Performance",
  total_sms_sent: "SMS Campaign sent",
  success_rate: "Success rate",
  sent_sms: "Sent SMS",
  sent_on: "Sent on",
  event: "Event",
  email_sent: "Email Campaign sent",
  total_opens: "Total opens",
  unsubscribed: "Unsubscribed",
  open_rate: "Open rate",
  blast_email: "Blast Email",
  delete_campaign: "Delete campaign",
  send_email: "Send Email",
  send_email_to_customer: "Send email to your customer",
  send_email_to_customer_desc: "Write your email to be sent to customer below",
  confirmation_send_email_donor: "Are you sure you want to send this email to your donors?",
  email_preview: "Email Preview",
  send_email_placeholder_1: "Subject: Promotion on the product",
  send_email_placeholder_2: "This would be the input for long text. It can contain longer text. When the input exceeds the vertical size of this field, scrolling mech will be enabled.",
  you_cant_undo_send_email: "You can’t undo this action once you sent the email. Click “Send” to proceed.",
  subject: "Subject",
  type_something: "Type something",
  sharing_embed: "Add this campaign to a website",
  sharing_embed_desc: "Copy this code snippet and paste it onto your website where you'd like the form to appear.",
  how_to_add_campaign: "How to do you want to add this campaign to your website?",
  as_a_floating_button: "As a floating button",
  as_a_page: "As a page (iFrame)",
  choose_link: "Choose link",
  donation_page: "Donation page",
  donation_form: "Donation form",
  get_code: "Get code",
  copy_paste_embed: "Copy and paste in your website editor",
  embed_code: "Embed code",
  copy_code: "Copy code",
  appointment: "Appointment",
  patient: "Patient",
  add_segment: "Add segment",
  confirmation_send_message_customers: "Are you sure you want to send this message to your customers?",
  confirmation_send_email_customers: "Are you sure you want to send this email to your customers?",
  add_donor: "Add donor",
  campaign_ranking: "Campaign Ranking",
  fundraiser_ranking: "Fundraiser Ranking",
  optional_tips: "Optional tips",
  optional_tips_desc: "We won't charge you 3% platform fee by turning this on",
  transfer_transaction_fee: "Transfer transaction fee to donor",
  transfer_transaction_fee_desc: "Turn this on if you want donors to cover the transaction fees.",
  recurring_donation: "Recurring donation",
  recurring_donation_desc: "Configure the recurring payment options for your campaign. This feature only available for credit card payments",
  offer_recurring_donation: "Offer recurring donation",
  offer_recurring_donation_desc: "Turn on this if you want to let your donors to donate with recurring",
  company_info: "Company info",
  patient_info: "Patient info",
  provider: "Provider",
  search_patient: "Search patients",
  show_patient: "Show patient",
  add_patient: "Add patient",
  delete_donor: "Delete donor",
  enter_email: "Enter email address",
  change_to: "Change to",
  services: "Services",
  patient_form: "Patient form",
  company_name: "Company name",
  new_provider: "New provider",
  empty_providers: "You don’t have any providers yet.",
  empty_providers_desc: "Provider is the person incharge for made service and appointment",
  create_provider: "Create provider",
  create_provider_type: "Create provider type",
  create_new_provider: "Create new provider",
  edit_provider: "Edit provider",
  delete_provider: "Delete provider",
  provider_detail: "Provider’s detail",
  provider_detail_desc: "Set profile image, name and type of provider",
  profile_image: "Profile image",
  provider_name: "Provider’s name",
  provider_name_placeholder: "Enter provider's name",
  type_of_provider: "Type of provider",
  type_of_provider_placeholder: "Choose type of provider",
  search_or_add_new: "Search or add new",
  existing_type_of_provider: "Existing type of provider",
  provider_availability: "Provider’s availability",
  provider_availability_desc: "Set the availibility for this provider",
  configure_times_available: "Configure times you are available for work",
  set_weekly_hours: "Set weekly hours",
  add_date_overrides: "Add date overrides",
  add_date_overrides_desc: "Add dates when your avalability changes from your weekly hours",
  add_date_override: "Add a date override",
  unavailable: "Unavailable",
  copy_timing_to: "Copy timing to",
  select_dates_override: "Select the date(s) you want to override with specific hours",
  set_new_timing: "Set new timing for selected date",
  set_new_timing_desc: "This will be overidden on top of your default schedule. Delete all timings to make this date unavailable.",
  integration: "Integration",
  integration_details: "Custom domain and webhook settings",
  provider_service: "Provider’s service",
  provider_service_desc: "Set the service for this provider",
  configure_type_services: "Configure type of services that this provider provide",
  add_service: "Add service",
  empty_assign_services: "You don’t assign any services yet.",
  empty_assign_services_desc: "You can start assign services by clicking “+ Add service” ",
  new_service: "New service",
  booking_fee: "Booking fee",
  duration: "Duration",
  edit_service: "Edit service",
  delete_service: "Delete service",
  create_service: "Create service",
  create_new_service: "Create new service",
  service_details: "Service details",
  service_details_desc: "Set the name and duration of the service",
  service_name: "Service name",
  service_name_placeholder: "Enter service name",
  service_description: "Service description",
  service_description_placeholder: "Enter description",
  service_duration: "Service duration",
  delete_confirmation: "Are you sure you want to delete this {text}?",
  delete_confirmation_desc: "This {text} will be deleted immediately. You can't undo this action.",
  how_many_times_service: "How many times can this service be done at one time? (Optional)",
  how_many_times_service_desc: "Please consider limitation on machines and rooms",
  unlimited_times: "Unlimited times",
  limited_times: "Limited times",
  limited_times_desc: "Type in amount of times this service can be done at one time",
  times_at_one_time: "time(s) at one time",
  when_patients_schedule: "When can patients schedule appointment?",
  when_patients_schedule_desc: "Set a range of dates when you can accept appointments from patients",
  patient_must_schedule: "Patient must schedule appointment",
  before_appointment_start: "before an appointment start time",
  is_booking_fee_required: "Is booking fee required to schedule for this service?",
  type_booking_fee_amount: "Type in booking fee amount",
  preliminary_questions_opt: "Preliminary questions (Optional)",
  preliminary_questions_opt_desc: "Some services may need some preliminary required questions to be asked to the patient. Eg: In what week is your pregnancy now?",
  create_preliminary_question: "Create preliminary question",
  empty_services: "You don’t have any services yet.",
  empty_services_desc: "Service determine the type of appointment that patient makes",
  empty_assign_providers: "You don’t assign any providers yet.",
  empty_assign_providers_desc: "You can start assigning provider by clicking “+ Add provider” ",
  add_provider: "Add provider",
  Who_service_conducter: "Who can do this service?",
  Who_service_conducter_desc: "who can conduct this service, time slot available will be depending on providers timing",
  providers_list: "Providers list",
  services_list: "Services list",
  patient_information_form: "Patient’s information form",
  patient_information_form_desc: "Manage your patient information form",
  telephone_number: "Telephone number",
  id_info: "NRIC/Passport",
  add_field: "Add field",
  create_input_field: "Create new input field",
  fill_the_information_below: "Fill the information below",
  input_type: "Input type",
  label_title_of_question: "Label (Title of question)",
  placeholder: "Placeholder",
  placeholder_desc: "This will appear on your field before filling",
  is_required: "Is required",
  select_input_type: "Select input type",
  enter_label_name: "Enter label name",
  enter_answer: "Enter answer",
  add_answer: "Add answer",
  list_of_answers: "List of answers",
  enter_placeholder: "Enter placeholder",
  field: "Field",
  create_question_field: "Create preliminary question field",
  label_title_of_the_question: "Label (Title of question / the question)",
  add_question: "Add question",
  upcoming: "Upcoming",
  no_show: "No-show",
  cancelled: "Cancelled",
  whatsapp_message_template: "WhatsApp message template",
  whatsapp_message_template_desc: "Setup this message to send reminder to patients in just one-click",
  upcoming_reminder_template: "Upcoming reminder template",
  upcoming_reminder_template_desc: "Write an upcoming reminder template message that will send to your patient.",
  current_template: "Current template",
  current_template_placeholder: "Hi Sarah Danial!\r\n\r\nWe see that you missed your appointment with Dr Jamal at 2:00 PM.\r\n\r\nWould you like to book another appointment? You can do so here:\r\n\r\nclinic.yezza.co/appointment",
  review_reminder_template: "Thank you message template",
  review_reminder_template_desc: "Write an review template message that will send to your patient.",
  edit_template: "Edit template",
  no_show_reminder_template: "No-show reminder template",
  no_show_reminder_template_desc: "Write an no-show template message that will send to your patient.",
  new_appointment: "New appointment",
  fill_up_appointment_details: "Please fill up the appointment details",
  service_type: "Service type",
  select_service_type: "Select service type",
  doctor: "Doctor",
  select_doctor: "Select doctor",
  appointment_date: "Appointment date",
  select_appointment_date: "Select appointment date",
  available_time: "Available time",
  select_available_time: "Select available time",
  type_patient_identification: "Type in patient’s identification number",
  nric_passport: "NRIC / Passport",
  enter_nric_passport: "Enter NRIC or Passport",
  email_optional: "Email (Optional)",
  phone_optional: "Phone number (Optional)",
  address_optional: "address (Optional)",
  booking_fees: "Booking fees",
  this_service_requires_payment: "This service requires payment, you may record it now",
  this_service_doesnt_requires_payment: "This service doesn’t require payments. You can proceed to confirm booking.",
  record_payment_now: "Record payment now",
  record_payment_later: "Record payment later",
  select_payment_method: "Select payment method",
  notes_on_payment_optional: "Notes on payment (optional)",
  notes_on_payment: "Notes on payment",
  store_link: "Store link",
  time: "Time",
  confirm_booking: "Confirm booking",
  no_fees_required: "No fees required",
  mark_as_arrived: "Mark as arrived",
  reschedule_new_date: "Reschedule to a new date",
  cancel_this_appointment: "Cancel this appointment",
  cancel_appointment: "Cancel appointment",
  create_followup_appointment: "Create follow-up appointment",
  record_payment: "Record payment",
  mark_patient_arrived_confirmation: "Are you sure you want to mark this patient as arrived?",
  change_appointment_date_time: "Change the appointment date and time",
  patient_details: "Patient’s details",
  why_cancel_appointment: "Why do you want to cancel this appointment? (optional)",
  state_reason_here: "State your reason here",
  last_appointment_date: "Last appointment date",
  choose_appointment_details: "Choose appointment details",
  appointment_details: "Appointment details",
  edit_appointment_details: "Edit appointment details",
  make_change_on_details: "Make change on the following details",
  edit_patient_detail: "Edit patient detail",
  booking_name: "Booking name",
  booking_phone_number: "Booking phone number",
  booking_email: "Booking email",
  preliminary_questions: "Preliminary questions",
  reason_for_cancellation: "Reason for cancellation",
  page_setup: "Page setup",
  booking_fee_desc: "Type in booking fee amount",
  please_use_gmail: "Please Sign Up using Gmail",
  mark_sent_pending: "Mark sent status as pending",
  mark_sent_pending_confirmation: "Are you sure you want to mark this patient sent status to pending?",
  mark_sent_pending_confirmation_desc: "The sent status will be changed to “Pending” immediately. You can’t undo this action.",
  potential_sales: "Potential sales",
  notes: "Notes",
  notes_optional: "Notes (Optional)",
  booking_notes: "Booking notes",
  edit_fundraiser: "Edit fundraiser",
  add_fundraiser: "Add fundraiser",
  raised: "Raised",
  audience: "Audience",
  appointment_page_language: "Appointment page language",
  appointment_page_language_desc: "Configure your preferred language for your appointment page",
  pre_appointment_instruction_optional: "Pre-appointment instruction (Optional)",
  pre_appointment_instruction: "Pre-appointment instruction",
  pre_appointment_instruction_placeholder: "1. Drink water and do not urinate before your ultrasound scan.\n2.",
  pre_appointment_instruction_desc: "Some services may need some pre-appointment instructions to be reminded to the patient. Eg: Drink water and do not urinate before your ultrasound scan.",
  label_title_of_instruction: "Label (Title of instruction)",
  before_appointment: "Before appointment",
  post_appointment_instruction_optional: "Post-appointment instruction (Optional)",
  post_appointment_instruction: "Post-appointment instruction",
  post_appointment_instruction_placeholder: "1. Get plenty of rest as much as possible to cope with fatigue.\n2.",
  post_appointment_instruction_desc: "Some services may need some post-appointment instructions to be reminded to the patient. Eg: Get plenty of rest as much as possible to cope with fatigue. ",
  after_appointment: "After appointment",
  edit_message: "Edit Message",
  tips_to_format: "Tips to Format Text in WhatsApp",
  appointment_link: "Appointment link",
  search_transaction: "Search transaction",
  show_transaction: "Show transaction",
  edit_transaction: "Edit transaction",
  new_donation: "New donation",
  donation_amount_date_created: "Enter donation amount and date created",
  add_more_donation: "Add more donation",
  delete_donation: "Delete donation",
  donation: "Donation",
  first_name: "First Name",
  last_name: "Last Name",
  commission_optional: "Commission (Optional)",
  bank_transfer: "Bank transfer",
  bank_transfer_desc: "Allow patients to pay online via major banks",
  pay_at_counter: "Pay at counter",
  pay_at_counter_desc: "Allow patients to pay manually at counter",
  qr_pay: "QR pay",
  qr_pay_desc: "Allow patients to pay via QR scan",
  manual_payment: "Manual payment",
  manage_your_services: "Manage your services",
  create_category: "Create category",
  category_name: "Category name",
  enter_category_name: "Enter category name",
  assign_service_to: "Assign service to",
  search_service: "Search service",
  assign_more_services_to: "Assign more services to",
  sort_category: "Sort category",
  rearrange_your_category: "Rearrange your category",
  rename_category: "Rename category",
  delete_category_desc: "This category will be deleted immediately. All of the service assigned will be uncategorized. Click 'Confirm' to proceed.",
  type_to_search: "Type to search...",
  reassign_category: "Reassign category",
  remove_from_category: "Remove from category",
  assign_to_category: "Assign to category",
  create_a_service: "Create a service",
  empty_services_category_desc: "Create service before assigning to a category",
  no_service_found: "No service found",
  choose_category: "Choose category",
  last_service: "Last service",
  enter_first_name: "Enter first name",
  enter_last_name: "Enter last name",
  remove_service_confirmation: "Are you sure you want to remove service from this category?",
  remove_service_desc: "This service will be uncategorized. Click 'Confirm' to proceed.",
  rename: "Rename",
  display_service_fee: "Do you want to display full service price?",
  service_fee_amount: "Service fee amount",
  service_photo_optional: "Service photos (optional)",
  service_photo_desc: "For best image optimization, upload JPG image with 1:1 (square) dimension.",
  make_cover_photo: "Make cover photo",
  delete_photo: "Delete photo",
  appt_date_selection_preference: "Appointment date selection preference",
  appt_date_selection_preference_desc: "Configure your preferred date selection in your appointment page",
  show_calendar_first: "Show calendar first",
  show_provider_availability: "Show provider’s availability based on nearest date",
  roles: "Roles",
  user_log: "User log",
  user_roles: "User roles",
  user_roles_desc: "Manage user access to your Clinic Management system",
  edit_user: "Edit user",
  delete_user: "Delete user",
  invite_new_user: "Invite new user",
  admin: "Admin",
  admin_desc: "Access all settings and actions available on Yezza.",
  clinic_assistant: "Clinic assistant",
  clinic_assistant_desc: "Only allow user to manage Appointment & Segments, setup Services & Providers and send WhatsApp, SMS, email to patients.",
  user: "User",
  question: "Question",
  segment: "Segment",
  main_admin: "Main admin",
  // Review
  review: "Review",
  google_review: "Google review",
  feedbacks: "Feedbacks",
  total_review: "Total review",
  all_ratings: "All ratings",
  five_star_review: "5-star review",
  four_star_review: "4-star review",
  three_star_review: "3-star review",
  two_star_review: "2-star review",
  one_star_review: "1-star review",
  invitations: "Invitations",
  get_more_reviews: "Get more reviews",
  review_settings: "Review settings",
  review_setup: "Review setup",
  review_page: "Review page",
  review_page_setup: "Review page setup",
  review_page_setup_description: "Fill in the field to complete your page and email template",
  company_logo_description: "Accepted format: JPG. and PNG.",
  review_page_heading: "Heading",
  review_page_heading_hint: "This would appear as big text in your page",
  review_page_heading_placeholder: "Eg: We would love your feedback",
  review_page_description: "Description",
  review_page_description_placeholder: "Thank you for your visit!\nWe hope you had a great experience with our service. We would really appreciate it if you could take a moment to leave a review.",
  review_page_rating_scale: "Rating scale",
  review_page_rating_scale_description: "Fill in the description and review destination",
  review_page_rating_scale_scale: "Scale",
  review_page_rating_scale_scale_description: "Description*",
  review_page_rating_scale_scale_send_to: "Send to",
  review_page_preview_title: "Preview",
  review_page_preview_rate_question: "How would you rate your experience?",
  email_setup: "Email setup",
  email_setup_description: "Fill in the field to complete your email template",
  email_setup_subject_line: "Email subject line",
  email_setup_subject_line_placeholder: "Enter email subject line here",
  email_setup_subject_line_hint: "The email subject line is only used when sending email",
  email_setup_notification_preview_line: "Email notification preview line",
  email_setup_notification_preview_line_placeholder: "Enter email notification preview line",
  email_setup_notification_preview_line_hint: "This will reflects in your patient’s email notification",
  email_setup_preview_subject_title: "Email subject preview",
  email_setup_preview_notification_title: "Notification preview",
  sms_whatsapp_message_template: "SMS and WhatsApp message template",
  sms_whatsapp_message_template_description: "Write a custom automated message to be sent when requesting review via SMS or WhatsApp",
  sms_whatsapp_message_template_current_template: "Current template",
  sms_whatsapp_message_template_edit_template: "Edit template",
  review_link: "Review link",
  connect_google_business_page: "Connect your Google Business page",
  connect_google_business_page_description: "Use this Google review link to get reviews from your customers.",
  feedback_form: "Feedback form",
  feedback_form_description: "Manage your feedback form",
  feedback_form_description_2: "Manage your feedback form questions",
  google_review_listing_empty_primary_text: "You don’t have any google review yet",
  google_review_listing_empty_secondary_text: "Send review invite to start receiving google review",
  feedback_listing_empty_primary_text: "You don’t have any feedbacks yet",
  feedback_listing_empty_secondary_text: "Send review invite to start receiving feedbacks",
  invitation_listing_empty_primary_text: "You don’t have anyone to invite yet",
  invitation_listing_empty_secondary_text: "{text} will show up here",
  invitation_listing_empty_review_text: "Any customer list available for review",
  invitation_listing_empty_clinic_text: "Any completed appointment",
  google_review_assign_item: "Assign to {item}",
  assign_to_item_tooltip_text: "By syncing the review, you can view the {item} details from this page",
  google_review_view_item_details: "View {item} details",
  reply_review: "Reply review",
  post_reply: "Post reply",
  replied: "Replied",
  response: "Response",
  your_response: "Your response",
  reassign_to_another_item: "Reassign to another {item}",
  unassign_this_item_from_review: "Unassign this {item} from review",
  add_internal_notes: "Add internal notes",
  internal_notes: "Internal notes",
  your_notes: "Your notes",
  send_review_invite: "Send review invite",
  invite_via: "Invite via",
  reload_now_to_send_message: "Reload now to start sending message",
  invite_via_whatsapp: "Invite via WhatsApp",
  invite_via_email: "Invite via email",
  invite_via_message: "Invite via message",
  start_sending_review_requests: "Start sending review requests from the table below ",
  dismiss: "Dismiss",
  review_delete_confirmation_description_primary: "{text} will be removed immediately",
  review_delete_confirmation_description_secondary: "You can't undo this action. Click “Confirm” to proceed.",
  connect_google_review: "Connect your Google Review",
  connect_google_review_description: "Start collecting new reviews, syncing current reviews and responding to reviews in one place",
  connect_now: "Connect now",
  add_review_site: "Add review site",
  google_account: "Google account",
  select_connection: "Select a {connectionType} to connect to",
  select_connection_description: "Confirm which {connectionType} in your Google business that you would like to connect your review to",
  confirm_connection: "Confirm connection",
  confirm_connection_description: "You are about to connect {connection} {connectionType} to {company} review. To edit this, press “Back” or",
  change_connection: "change {connectionType}",
  reconnect: "reconnect",
  google_review_link: "Google Review link",
  how_to_find_google_review_link: "How to find your Google Review link",
  paste_google_review_link: "Paste your Google Review link here",
  google_review_link_placeholder: "https://g.page/r/xxxxxxxxxxxxx/review",
  review_error_message: "Oopss.. Something went wrong. Kindly contact support for further action",
  review_select_another_account: "Your selected account doesn't have any Google My Business (GMB) {connectionType}. Please connect another account to proceed",
  google_review_response: "Google review response",
  invited: "Invited",
  error_stats: "Unable to show stats data due to error. Kindly contact support for further action",
  assign_item: "Assign {item}",
  assign_item_description: "Select which {item} to assign the review with:",
  select_item: "Select {item}",
  select_item_placeholder: "Choose {item}...",
  unassign_review: "Are you sure you want to unassign this review?",
  unassign_item_description: "The {item} assigned will be removed immediately. You can’t undo this action. Click “Confirm” to proceed.",
  item_not_found: "No {item} found",
  item_not_found_description: "Please try another filter/search or clear your filter/search selection",
  filter_cleared: 'Filter cleared',
  filter_rating: 'Filter Rating',
  filter_status: 'Filter Status',
  filter_reply_status: 'Filter Reply Status',
  filter_last_update: 'Filter Last Update',
  filter_last_appointment_update: 'Filter Last Appointment Update',
  filter_last_appointment_update_description: 'Filter appointment completed on:',
  filter_review_made_on: "Filter review made on:",
  choose_rating_to_filter: "Choose the rating that you want to filter:",
  choose_reply_status_to_filter: "Choose the reply status that you want to filter:",
  registration: "Registration",
  consultation: "Consultation",
  insights: "Insights",
  add_new_question: "Add new question",
  on: "On",
  off: "Off",
  active: "Active",
  inactive: "Inactive",
  make_required: "Make this question required",
  enter_title: "Enter title",
  internal_feedback: "Internal feedback",
  submitted_at: "Submitted at",
  download_all_responses: "Download all responses",
  assign_team: "Add tagging",
  feedback_form_preview_title: "Preview",
  submit_feedback: "Submit feedback",
  preview_address: {
    address_1: {
      label: "Address Line 1",
      placeholder: "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    address_2: {
      label: "Address Line 2",
      placeholder: "e.g. IOI Resort City"
    },
    postcode: {
      label: "Postcode",
      placeholder: "e.g. 62502"
    },
    city: {
      label: "City",
      placeholder: "e.g. Putrajaya"
    },
    state: {
      label: "State",
      placeholder: "e.g. Wilayah Persekutuan Putrajaya"
    },
    country: {
      label: "Country",
      placeholder: "e.g. Malaysia"
    }
  },
  api_key: "API key",
  api_key_description: "The following are your API Keys. API keys are used for reading data from Yezza & manipulating some sensitive objects such as lists.",
  api_key_description_2: "API keys should be treated like your password, kept in a safe place and never exposed to the public.",
  no_api_key_title: "You don’t have any API Key yet",
  no_api_key_description: "Start creating API key now to access your API key",
  generate_api_key: "Generate API Key",
  revoke_and_generate_api_key: "Revoke & generate a new key",
  revoke_confirmation_title: "Are you sure you want to revoke your API key?",
  revoke_confirmation_description: "Everything associated with this key will be permenantly deleted.\nThis action cannot be undone.",
  revoke_confirmation_label: "Type “DELETE” to confirm",
  integration_plugin: "Integration and Plugin",
  integration_plugin_general_description : "This API key can be used to connect with Woocommerce, Shopify and other platform.",
  integration_plugin_shopify: "Automatically create review invitation when receiving orders or updating orders in Shopify. Copy the integration link and follow the guide",
  integration_plugin_woocommerce: "Automatically create review invitation when receiving orders or updating orders in WooCommerce. Download and install the Woocommerce Review plugin",
  import_csv: "Import CSV",
  upload_csv: "Upload CSV",
  map_fields: "Map fields",
  choose_a_file: "Choose a file",
  upload_csv_file_containing_users: "Upload a CSV file containing users to invite for review",
  maximum_file_size_1mb: "Maximum file size: 1 MB",
  match_column_labels_to_customers: "Match column labels to customers information",
  columns_have_been_recognize: "column have been recognized in this file. | columns have been recognized in this file.",
  please_map_all_column: "Please map all of the column that you want to import",
  continue_mapping: "Continue mapping",
  finish_mapping: "Finish mapping",
  mapping_field_confirmation_yes: "Yes, continue",
  mapping_field_confirmation_no: "No, I want to make changes",
  csv_import_success_title: "You're good to go.",
  csv_import_success_description: "No error detected. Click Finish to complete setup.",
  csv_import_error_title: "Error detected during the import",
  csv_import_error_description: "{count} customer(s) are affected by these errors. Please fix the error and reupload a new file.",
  sample_data: "Sample data",
  review_automation: "Review Automation",
  review_automation_description: "Automate the process of sending email or SMS to collect review from your customers",
  review_automation_sending_type_label: "How to send review link to you customers?",
  review_automation_sending_type_automatic_label: "Automatically send the review",
  review_automation_sending_type_manual_label: "Manually send the review",
  review_automation_sending_method_label: "Choose sending method",
  review_automation_sending_method_sms: "SMS",
  review_automation_sending_method_email: "Email",
  collect_review_after: "Collect review after",
  review_item_details: "{item} details",
  customer_detail: "Customer’s detail",
  edit_item_detail: "Edit {item} detail",
  existing_item: "Existing {item}",
  ignore_and_remove_all_rows_data: "Ignore and remove all rows and data with errors.",
  added_by: 'Added by',
  clinic_appointment_page: 'Clinic Appointment Page',
  payment_date: 'Payment Date',
  payment_details: 'Payment Details',
  // Clinic Management System
  existing_nric_passport: "Existing NRIC / Passport",
  add_new_nric: "Add new NRIC / Passport",
  filter_by: "Filter by",
  type_a_value: "Type a value",
  age: "Age",
  enter_age: "Enter age",
  urgency: "Urgency",
  urgent: "Urgent",
  non_urgent: "Non-urgent",
  arrived_date: "Arrived date",
  to: "To",
  no_doctors_found: "No doctors found",
  serving: "Serving now",
  schedule_for_today: "Schedule for today",
  waiting: "Waiting",
  on_hold: "On hold",
  dispensary: "Dispensary",
  view_profile: "View profile",
  allergy: "Allergy",
  allergies: "Allergies",
  underlying_conditions: "Underlying Conditions",
  call_patient_in: "Call patient in",
  in_queue: "In-queue",
  put_on_hold: "Put on hold",
  resume_consultation: "Resume consultation",
  complete_consultation: "Complete consultation",
  call_to: "Call to",
  view_all_waiting_patients: "View all waiting patients",
  visit_note: "Visit note",
  allergy_note: "Allergy note",
  item_delete_confirmation_description_primary: "{item} will be removed immediately",
  item_delete_confirmation_description_secondary: "You can't undo this action. Click “Confirm” to proceed.",
  quantity: "Quantity",
  price_tier: "Price Tier",
  dosage: "Dosage",
  frequency: "Frequency",
  instruction: "Instruction",
  precaution: "Precaution",
  out_of_stock: "Out of stock",
  medical_certificate: "Medical certificate",
  date_of_visit: "Date of visit",
  diagnosis: "Diagnosis",
  start_date: "Start date",
  end_date: "End date",
  time_in: "Time in",
  time_out: "Time out",
  enter_item: "Enter {item}",
  reaction: "Reaction",
  add_allergy: "Add allergy",
  self_pay: "Self-pay",
  patient_history: "Patient history",
  visit: "Visit",
  treatments: "Treatments",
  documents: "Documents",
  all_time: "All time",
  past_1_month: "Past 1 month",
  past_3_months: "Past 3 months",
  past_6_months: "Past 6 months",
  past_12_months: "Past 12 months",
  clear_sort: "Clear sort",
  newest_to_oldest: "Newest to oldest",
  oldest_to_newest: "Oldest to newest",
  view_details: "View details",
  record_new_diagnose: "Record a new diagnose",
  attended_by: "Attended by {who}",
  case_notes: "Case notes",
  medication: "Medication",
  services_and_treatments: "Services & Treatments",
  add_to_current: "Add to current",
  add_to_current_plan: "Add to current plan",
  view_all_details: "View all details",
  view_diagnosis: "View diagnosis",
  view_medication_details: "View medication details",
  view_document: "View document",
  choose_and_add_to_current_plan: "You can choose and add to current plan",
  side_effect: "Precaution",
  attach_photo: "Attach photo",
  upload_photo_from_other_device: "Upload photo from other device",
  scan_qr_code_below_to_upload: "Scan QR code below to upload photo from your other devices (Eg: mobile phone, tablet)",
  uploaded: "uploaded",
  over_the_counter: "Over the counter",
  add_item_from_medical_record: "Add item from past medical record",
  download_item: "Download {item}",
  billed_to: "Billed to",
  billing_details: "Billing details",
  change_billing_details: "Change billing details",
  add_adjustment: "Add Adjustment",
  proceed_to_payment: "Proceed to payment",
  balance: "Balance",
  medication_record: "Medication record",
  add_to_dispensary: "Add to dispensary",
  past_medication_record: "Past medication record",
  past_medication_record_description: "Select any record(s) and send it to dispensary",
  send_to_waiting_area: "Send to waiting area",
  go_to_invoice: "Go to invoice",
  summary: "Summary",
  call_in: "Call in",
  print_all_item: "Print all {item}",
  download_all_item: "Download all {item}",
  labels: "Labels",
  edit_item: "Edit {item}",
  photo: "Photo",
  verify_panel_info: "Verify panel info",
  print_item: "Print {item}",
  add_item: "Add {item}",
  adjustment: "Adjustment",
  paid: "Paid",
  amount_due: "Amount due",
  back_to_checkout: "Back to checkout",
  billing_info: "Billing info",
  add_payment_note: "Add payment note",
  add_or_deduct_from_amount: "Would you like to add or deduct from amount?",
  deduct: "Deduct",
  choose_type: "Choose type",
  fixed_amount: "Fixed amount",
  percentage: "Percentage",
  enter_adjustment_amount: "Enter adjustment amount",
  templates: "Templates",
  template: "Template",
  medical_records: "Medical records",
  billings: "Billings",
  in_clinic: "In-clinic",
  clinic_management: "Clinic management",
  business_management: "Business management",
  registration_settings: "Registration settings",
  manage_registration_settings_description: "Set required details in registration",
  consultation_settings: "Consultation settings",
  manage_consultation_settings_description: "Manage preset diagnosis in consultation",
  checkout_settings: "Checkout settings",
  manage_checkout_settings_description: "Manage panel and self-pay payments",
  inventory_and_services: "Inventory & services",
  manage_inventory_description: "Manage your practice items",
  manage_services_description: "Manage your practice services",
  manage_inventory_and_services_settings_description: "Configure your price tiers, medicine details & suppliers",
  patients: "Patients",
  information_and_medical_records: "Information & medical records",
  manage_information_and_medical_records_description: "Patient information & medical records",
  segments_blasting: "Segment and Blasting",
  segments_blasting_description: "Patient Segmentation and Retargetting",
  billing_records: "Billing records",
  manage_billing_records_description: "Access patient medical records",
  import_patients: "Import patients",
  manage_import_patients_description: "Import patient from third-party services",
  appointment_calendar: "Appointment calendar",
  manage_appointment_calendar_description: "List of all appointments",
  manage_appointment_calendar_settings_description: "Configure your appointment system",
  reviews: "Reviews",
  reviews_and_feedbacks: "Reviews & feedbacks",
  manage_reviews_and_feedbacks_description: "List of all reviews & feedbacks",
  manage_reviews_and_feedbacks_settings_description: "Configure your review system",
  manage_queue_settings_description: "Configure your queue system",
  queue: "Queue",
  queue_screen: "Queue screen",
  manage_queue_screen_description: "Open queue screen for display",
  manage_users_description: "Manage your providers",
  rooms_and_equipments: "Rooms & equipments",
  manage_rooms_and_equipments_description: "Manage your rooms & equipments",
  hardware: "Hardware",
  printers: "Printers",
  manage_printers_description: "Configure printers",
  mykad_reader: "MyKad reader",
  manage_mykad_reader_description: "Configure MyKad reader",
  manage_templates_description: "Manage templates for medical records & billings",
  your_business: "Your business",
  business_details: "Business details",
  manage_business_details_description: "Set your business details",
  tax_settings: "Tax settings",
  manage_tax_settings_description: "Setup tax to be used in checkout process",
  payment_gateway: "Payment gateway",
  manage_payment_gateway_description: "Configure your preferred payment gateway",
  user_management: "User management",
  permission: "Permission",
  manage_permission_description: "Set permission for users",
  manage_commissions_description: "Set commission rates of users",
  need_help: "Need help?",
  contact_us: "Contact us",
  appointment_settings: "Appointment settings",
  create_new_template: "Create new template",
  new_template_description: "Create and customize your template",
  new_template_subdescription: "Fill in the information below and start creating",
  edit_template_description: "Edit your template",
  edit_template_subdescription: "Edit your information below and save your changes",
  template_setup: "Template setup",
  template_name: "Template name",
  template_name_placeholder: "Enter template name",
  template_description: "Template description",
  template_description_placeholder: "Enter description",
  template_category: "Template category",
  medical_records_description: "Referral letter, time slip, memo",
  invoice_description: "Templates for invoices",
  receipt_description: "Templates for receipts",
  header_description: "Setup your header with logo, clinic name, address and telephone number.",
  logo: "Logo",
  clinic_name: "Clinic name",
  clinic_phone: "Clinic phone",
  tel_number: "Tel number",
  set_header_now: "Set header now",
  edit_header_now: "Edit header now",
  clinic_name_placeholder: "Enter clinic name",
  clinic_phone_placeholder: "Enter phone number",
  compose_content: "Compose content",
  insert_smart_fields: "Insert smart fields",
  smart_fields_description: "This fields allow system to automatically insert existing data. No manual editing needed",
  patient_name: "Patient name",
  doctor_name: "Doctor name",
  visit_date: "Visit date",
  identification: "Identification",
  footer_description: "Upload photo as your footer. Enable this if you want image footer in your template. Eg: Logo, company info, contact details",
  click_to_upload: "Click to upload",
  or_drag_and_drop: "or drag and drop",
  photo_upload_limitation: "JPG and PNG (max. 4MB)",
  pricing: "Pricing",
  pricing_description: "Set price and pricing tier for this template. You can manage your pricing tier in settings.",
  go_to_pricing_tier_settings: "Go to pricing tier settings",
  delete_template: "Delete template",
  template_preview: "Template preview",
  compose_content_description_item: "You can configure the properties that you want to showcase in your {item}",
  queue_system_settings: "Queue System Settings",
  queue_system_config: "Configuration",
  queue_system_config_description: "Setup your queue system preference",
  clear_queue: "Clear queue",
  clear_queue_description: "At what time you want to clear your queue?",
  qtv_preview: "QTV Preview",
  automatic_payments: "Automatic payments",
  manual_payments: "Manual payments",
  whatsapp_button: "WhatsApp button",
  whatsapp_button_description: "Let customer to send you WhatsApp message from the appointment page.",
  enable_whatsapp_button: "Enable WhatsApp button",
  clear_queue_checkbox_description: "I don't want to clear my queue automatically",
  call_your_patient_by: "Call your patient by",
  number: "Number",
  custom_numbering_group: "Custom numbering group",
  custom_numbering_group_description: "Differentiate between different type of patients.",
  room_setup: "Room setup",
  room_setup_description: "Setup your room in your queue system",
  queue_display: "Queue display",
  queue_display_description: "Configure your queue display",
  media_type: "Media type",
  video: "Video",
  language: "Language",
  scrolling_text: "Scrolling text",
  scrolling_text_description: "This text will slide in your QTV in loop",
  company_logo_preferred_dimension: "Preferred dimension: Aspect ratio of 16:9",
  change_theme_color: "Change theme color",
  rooms: "Rooms",
  equipments: "Equipments",
  room_equipment: "room / equipment",
  resource_detail: "Resource detail",
  limit_time_availability: "Limit time availability",
  limit_time_availability_description: "Turn this on to set availability schedule for this room or equipment. This is useful for limited resources, eg: X-Ray machine",
  facility_services_description: "Attach services to this room or equipment. You can create and manage your services in",
  optional: "Optional",
  type: "Type",
  add_room_or_equipment: "Add room or equipment",
  select_type: "Select type",
  record_new_tax_rate: "Record a new tax rate",
  clinic_email: "Clinic email",
  clinic_email_placeholder: "Enter email",
  add_tax: "Add tax",
  save_and_close: "Save & close",
  set_appointment: "Set appointment",
  set_appointment_description: "Please fill up the appointment details",
  new_appointment_made: "New appointment made",
  new_appointment_made_description: "This appointment is now available in your appointment page. To cancel this action, click",
  undo: "Undo",
  log_out: "Log out",
  account_settings: "Account settings",
  explore_features: "Explore features",
  upload_file: "Upload file",
  files: "Files",
  document_name: "Document name",
  enter_description: "Enter description",
  file_details: "File details",
  size: "Size",
  file_type: "File type",
  uploaded_by: "Uploaded by",
  no_document_selected: "No document selected",
  no_document_selected_description: "Select document on the left pane or start adding new medical document.",
  edit_file: "Edit file",
  file: "File",
  alignment: "Alignment",
  align_item: "Alignment {item}",
  left: "left",
  center: "center",
  right: "right",
  document_preview: "Document preview",
  editor: "Editor",
  complete_later: "Complete later",
  complete_document: "Complete document",
  unsaved_document_title: "You have unsaved changes",
  unsaved_document_description: "You have made updates in this document. Do you wish to save or discard them?",
  quit_and_discard: "Quit and discard",
  save_and_quit: "Save and quit",
  complete: "Complete",
  incomplete_document_title: "You have incomplete document",
  incomplete_document_description: "You still have incomplete documents in your treatment plan. Are you sure you want to procced?",
  ignore_and_proceed: "Ignore and proceed",
  continue_editing: "Continue editing",
  drug_label: "Drug label",
  drug_label_settings: "Drug label settings",
  drug_label_description: "Configure your drug label properties",
  properties: "Properties",
  required_by_system: "Required by system",
  drug_label_preview: "Drug label preview",
  edit_tax: "Edit tax",
  download_item_description: "You have more than one {item} templates. Confirm which template that you would like to download",
  item_templates: "{item} templates",
  print_receipt: "Print receipt",
  add_room: "Add room",
  choose_room: "Choose room",
  select_room: "Select room",
  display_name: "Display name",
  enter_display_name: "Enter display name",
  edit_room: "Edit room",
  automation: "Automation",
  primary: "Primary",
  thermal_printers: "Thermal printers",
  thermal_printers_description: "Setup your receipt printer according to your preference",
  edit_printer: "Edit printer",
  delete_printer: "Delete printer",
  select_printer: "Select only one printer below",
  searching_printers: "Searching printers",
  searching_printers_info: "Make sure you have installed desktop apps and local printer in your computer",
  paper_width: "Paper width",
  paper_height: "Paper height",
  paper_size_unit: "Paper size unit",
  printer: "Printer",
  hostname: "Hostname",
  cost: "Cost",
  price_to_patient: "Price to patient",
  group: "Group",
  cost_price: "Cost price",
  insight: "Insight",
  patient_database: "Patient database",
  patient_profile: "Patient profile",
  visits: "Visits",
  view_visit_summary: "View visit summary",
  total_spend: "Total spend",
  total_visit: "Total visit",
  since: "Since",
  due: "Due",
  visit_summary: "Visit summary",
  edit_diagnosis: "Edit diagnosis",
  amount_to_claim: "Amount to claim",
  select_diagnosis: "Select diagnosis",
  no_result_match: "No results match",
  medical_certificate_description: "Template for medical certificate",
  medical_certificate_instruction: "Fill out information below to complete document",
  no_of_days: "No of days",
  created_date: "Created date",
  medicine_reports: "Medicine reports",
  medicine_reports_description: "Download medicine reports",
  sales_reports: "Sales reports",
  closing_reports: "Closing reports",
  sales_reports_description: "Download sales reports",
  closing_reports_description: "Download closing reports",
  unpaid_balance: "Unpaid balance",
  seller: "Seller",
  invoice_no: "Invoice number",
  opt_in_booking: "Opt-in booking",
  opt_in_booking_description: "Set whether you would like to accept booking automatically or manually",
  approve_booking_auto: "Do you want to approve booking automatically?",
  yes_approve: "Yes, I would like to approve the service’s booking automatically.",
  yes_approve_description: "Bookings for this service will be approved automatically.",
  no_approve: "No, every new bookings will need to be approved.",
  no_approve_description: "Booking requests will be added to your dashboard. ",
  booking_details: "Booking details",
  edit_booking_details: "Edit booking details",
  inventory_services_packages: "Inventory, services & packages",
  manage_inventory_services_packages_description: "Manage your practice item, services & packages",
  birthday: "Birthday",
  staffid: "Staff ID",
  marketing: "Marketing",
  first_purchase: "First purchase",
  first_purchase_subtitle: "This automated message preset is to be sent to customers who visit your premise for the first time.",
  first_purchase_content_description: "Special offers to welcome new customers making their first purchase.",
  second_purchase: "Second purchase",
  second_purchase_subtitle: "This automated message preset is to be sent to customers who made purchase in your premise for the second time.",
  second_purchase_content_description: "Special offers to welcome customers back for their second visit.",
  birthday_subtitle: "This automated message preset is to be sent to customers who are celebrating their birthday",
  birthday_content_description: "Special offers sent to customers on their birthday.",
  reactivation: "Reactivation",
  reactivation_subtitle: "This automated message preset is to be sent to customers who has not visited your premise for more than 60 days",
  reactivation_content_description: "Special offers to bring back customers who haven't visited in a while.",
  rates: "Rates",
  choose_your_reload_amount: "Choose your reload amount",
  visit_frequency: "Visit frequency",
  activity: "Activity",
  not_visited_for: "Not visited for",
  visited_last: "Visited last",
  available: "Available",
  equals_to: "Equals to",
  between: "Between",
  insert_value: "Insert value",
  last_stamps_before_reward: "Last stamps before reward",
  date_of_birth: "Date of birth",
  whatsapp_review_message_template_description: "Write a custom automated message to be sent when requesting review via WhatsApp",
  bookings: "Bookings",
  reset_filters: "Reset filters",
  na: "N/A",
  enter: "Enter",
  email_must_be_valid: "Email must be valid",
  // Global panel-related translations
  admin_fee: "Admin fee",
  admin_fee_cannot_be_negative: "Admin fee cannot be negative",
  percentage_must_be_between_0_and_100: "Percentage must be between 0 and 100",
  percentage_must_be_integer: "Percentage must be integer",
  rejected_amount_cannot_be_negative: "Rejected amount cannot be negative",
  days_cannot_be_negative: "Days cannot be negative",
  days_must_be_integer: "Days must be integer",
  panel: {
    panel: "Panel",
    claim: "Claim",
    claims: "Claims",
    add_panel: "Add panel",
    panel_information: "Panel information",
    contact_information: "Contact information",
    fill_panel_info_below: "Fill in panel information below.",
    panel_type: "Panel type",
    third_party_administrator: "Third Party Administrator",
    direct_company: "Direct company",
    submission_delivery_preference: "Submission delivery preference",
    set_how_claims_delivered: "Set how claims are delivered to selected panel.",
    single_claim: "Single claim",
    bulk_claim: "Bulk claim",
    company_registration_number: "Company registration number",
    company_registration_number_description: "12-digit SSM ID required",
    company_name: "Company name",
    panel_name: "Panel name",
    panel_code: "Panel code",
    person_in_charge: "Person in charge",
    panel_verification: "Panel verification",
    provide_link_for_users: "Provide a link for users to review panel information.",
    url_to_panel_platform: "URL to panel platform",
    manual_remark: "Manual remark",
    verification_link: "Verification link",
    panel_rule: "Panel rule",
    set_operational_terms: "Set the operational terms for this panel.",
    claim_submission_due_date: "Claim submission due date",
    fixed_deadline: "Fixed deadline",
    relative_deadline: "Relative deadline",
    by: "by",
    select_price_tier: "Select price tier",
    manage_pricing_tier: "Manage your pricing tier in settings.",
    pricing_tier_setting: "Pricing tier setting",
    price_tier: "Price tier",
    e_invoice_setting: "E-invoice setting",
    e_invoice_setting_description: "This TIN will be used for e-invoice submission for panel claims.",
    income_tax_number_tin: "Income Tax Number (TIN)",
    panel_added_successfully: "Panel added successfully",
    please_enter_valid_url: "Please enter a valid verification URL",
    panel_name_tooltip: "A shorter name (e.g., AIA, Prudential etc) that will show in selection lists.",
    remarks: "Remarks",
    after_invoice_finalised: "after invoice is finalised",
    visits: "Visits",
    visits_description: "Below is a list of visits by panel employees to this clinic.",
    no_visits_found: "No visits found",
    view_invoice: "View invoice",
    view_claim: "View claim",
    create_claim: "Create claim",
    eligible_staffs: "Eligible staffs",
    eligible_staffs_description: "Below is a list of employees eligible for claims under this panel.",
    no_staff_found: "No staff found",
    view_staff_details: "View staff details",
    panel_reports: "Panel reports",
    download_panel_reports: "Download panel reports",
    panel_invoices: "Panel invoices",
    download_panel_invoices: "Download panel invoices",
    claims_message_templates: "Claims message templates",
    manage_message_templates_claims: "Manage message templates for claims",
    panel_management: "Panel Management",
    claim_message_template: "Claim message template",
    panel_configuration: "Panel configuration",
    staff_assignments: "Staff assignments",
    payment_integration: "Payment integration",
    message_template: "Message template",
    message_template_description: "Set up a pre-filled message to submit the claim to the panel. Copy and send it directly through your preferred channel.",
    single_claim_description: "This template will be used when submitting a single claim to the selected panels. Configure your message content before sending.",
    bulk_claim_description: "This template will be used when submitting a bulk claim to the selected panels. Configure your message content before sending.",
    set_now: "Set now",
    message_preview: "Message preview",
    edit_template: "Edit template",
    claim_message_template_setup: "Claim Message Template Setup",
    message_content: "Message content",
    message_content_description: "Define the message content that will be sent when submitting a claim.",
    insert_smart_fields: "Insert smart fields",
    smart_fields_description: "These fields allow system to automatically insert existing data.",
    billing_details: "Billing details",
    who_is_this_person: "Who is this person?",
    open_link: "Open link",
    enter_staff_id: "Enter staff ID",
    enter_chit_number: "Enter chit number",
    patient_nric: "Patient NRIC",
    staff_id: "Staff ID",
    chit_number: "Chit number",
    claim_number: "Claim number",
    total_invoice: "Total invoice",
    claimed_amount: "Claimed amount",
    submission_date: "Submission date",
    claim_link: "Claim link",
    mc_days: "MC days",
    diagnosis: "Diagnosis",
    medication: "Medication",
    clinic_name: "Clinic name",
    panel_claims: "Panel Claims",
    claim_for: "for",
    submitted_on: "Submitted on",
    updated_by: "Updated by",
    download_pdf: "Download PDF",
    send_claim: "Send claim",
    edit_claim: "Edit panel claim",
    revert_claim_to_invoice: "Revert claim to invoice",
    download_invoice: "Download invoice",
    download_receipt: "Download receipt",
    download_panel_claim: "Download panel claim",
    download_limit_exceeded: "You can only download up to 20 items at once",
    ssm_must_be_digits: "SSM ID must contain only digits.",
    ssm_must_be_12_characters: "SSM ID must be exactly 12 characters.",
    stats_submissions: "Submissions",
    stats_pending: "Pending",
    stats_overdue: "Overdue",
    stats_payouts: "Payouts",
    stats_approved: "Approved",
    stats_received: "Received",
    stats_rejected: "Rejected",
    stats_outstanding: "Outstanding",
    // Filter-related keys
    amount: "Amount",
    claim_type: "Claim type",
    name: "Name",
    doctor: "Doctor",
    visit_type: "Visit type",
    treatment: "Treatment",
    visit_date: "Visit date",
    // Comparison operators
    comparison: "Comparison",
    is: "Is",
    is_not: "Is not",
    less_than: "Less than",
    more_than: "More than",
    is_between: "Is between",
    greater_than: "Greater than",
    greater_than_or_equal: "Greater than or equal",
    less_than_or_equal: "Less than or equal",
    equal_to: "Equal to",
    between: "Between",
    // Amount fields
    minimum_amount: "Minimum amount",
    maximum_amount: "Maximum amount",
    // Date range fields
    minimum_days: "Minimum days",
    maximum_days: "Maximum days",
    days: "Days",
    // Patient name search
    patient_name: "Patient name",
    search_type: "Search type",
    contains: "Contains",
    starts_with: "Starts with",
    does_not_contain: "Does not contain",
    ends_with: "Ends with",
    enter_patient_name: "Enter patient name",
    // Claim number
    enter_claim_number: "Enter claim number",
    // Visit types
    consultation: "Consultation",
    follow_up: "Follow up",
    emergency: "Emergency",
    procedure: "Procedure",
    vaccination: "Vaccination",
    health_screening: "Health screening",
    // Date ranges
    date_range: "Date range",
    start_date: "Start date",
    end_date: "End date",
    today: "Today",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    this_month: "This month",
    last_month: "Last month",
    custom_range: "Custom range",
    // Date filter operators
    is_equal_to: "Is equal to",
    is_in_the_last: "Is in the last",
    is_after: "Is after",
    is_on_or_after: "Is on or after",
    is_before: "Is before",
    is_before_or_on: "Is before or on",
    weeks: "Weeks",
    months: "Months",
    years: "Years",
    // Claim types
    single: "Single",
    bulk: "Bulk",
    no_items_found: "No items found",
    // Invoice filter
    invoice_number: "Invoice number",
    enter_invoice_number: "Enter invoice number",
    due_date: "Due date",
    // Tab labels
    tab_all: "All",
    tab_pending: "Pending",
    tab_overdue: "Overdue",
    tab_submitted: "Submitted",
    tab_approved: "Approved",
    tab_rejected: "Rejected",
    tab_received: "Received",
    tab_cancelled: "Cancelled",
    tab_visits: "Visits",
    tab_eligible_staffs: "Eligible staffs",
    // Status labels
    status_submitted: "Submitted",
    status_approved: "Approved",
    status_rejected: "Rejected",
    status_received: "Received",
    status_pending: "Pending",
    status_overdue: "Overdue",
    status_cancelled: "Cancelled",
    // Dialog titles
    send_panel_claim: "Send panel claim",
    panel_claim_details: "Panel claim details",
    invoice_details: "Invoice details",
    selected_invoices: "Selected invoices",
    edit_bulk_panel_claim: "Edit bulk panel claim",
    create_bulk_panel_claim: "Create bulk panel claim",
    edit_panel_claim: "Edit panel claim",
    create_panel_claim: "Create panel claim",
    documents: "Documents",
    payments: "Payments",
    file_details: "File details",
    add_payment: "Add payment",
    edit_payment: "Edit payment",
    // Field labels
    panel_details: "Panel details",
    patient_details: "Patient details",
    treatment_items: "Treatment items",
    invoice_no: "Invoice no.",
    staff_details: "Staff details",
    treatments: "Treatments",
    total: "Total",
    claim_status: "Claim status",
    record_deductions: "Record deductions:",
    upload_photo: "Upload photo",
    add_from_other_devices: "Add from other devices",
    payment_method: "Payment method",
    payment_reference_no: "Payment reference no.",
    payment_type: "Payment type",
    payment_notes: "Payment notes (optional)",
    approved_amount: "Approved amount",
    rejected_amount: "Rejected amount",
    total_received: "Total received",
    amount_due: "Amount due",
    document_name: "Document name",
    type: "Type",
    size: "Size",
    date: "Date",
    uploaded_by: "Uploaded by",
    received_amount: "Received amount",
    payment_notes_label: "Payment notes",
    approved_date: "Approved date",
    item_name: "Item name",
    rate: "Rate",
    qty: "Qty",
    staff_id_field: "Staff ID",
    chit_no: "Chit no",
    visit: "Visit",
    nric: "NRIC",
    phone_number: "Phone number",
    email: "Email",
    visit_note: "Visit note",
    file_type: "File type",
    created: "Created",
    upload_date: "Upload date",
    submitted_date: "Submitted date",
    submitted_date_label: "Submitted date",
    submitted_amount: "Submitted amount",
    approved_date_label: "Approved date",
    approved_amount_label: "Approved amount",
    rejected_date_label: "Rejected date",
    rejected_amount_label: "Rejected amount",
    received_date_label: "Received date",
    received_amount_label: "Received amount",
    // Actions
    copy_message: "Copy message",
    done: "Done",
    add_document: "Add document",
    unselect_all: "Unselect all",
    online_banking: "Online banking",
    cheque: "Cheque",
    full_payment: "Full payment",
    partial_payment: "Partial payment",
    switch_to_list: "Switch to list",
    switch_to_thumbnail: "Switch to thumbnail",
    upload_new: "Upload new",
    // Messages
    panel_claim_created_successfully: "Panel claim has been created successfully. Send panel claim now?",
    copy_message_instruction: "Copy the message below and paste it into your email or WhatsApp to notify the panel.",
    scan_qr_instruction: "Scan this QR code to upload photo from your other devices (Eg: mobile phone, tablet)",
    message_copied: "Message copied to clipboard",
    failed_copy_message: "Failed to copy message",
    text_copied: "Text copied to clipboard",
    failed_copy_text: "Failed to copy text",
    link_copied: "Link copied to clipboard",
    failed_copy_link: "Failed to copy link",
    unable_to_generate_link: "Unable to generate link",
    documents_added: "Documents added successfully",
    failed_add_documents: "Failed to add documents. Please try again.",
    upload_at_least_one_document: "Please upload at least one document",
    qr_code_error: "Error on QR code. Please try again later.",
    syncing_files_error: "Error syncing files. Please try again later.",
    document_deleted: "Document deleted successfully",
    failed_delete_document: "Failed to delete document. Please try again.",
    payment_deleted: "Payment deleted successfully.",
    failed_delete_payment: "Failed to delete payment. Please try again.",
    invalid_payment_data: "Invalid payment data.",
    claim_created: "Claim created successfully",
    failed_create_claim: "Failed to create claim. Please try again.",
    claim_updated: "Claim updated successfully",
    failed_update_claim: "Failed to update claim. Please try again.",
    fill_required_fields: "Please fill in all required fields correctly.",
    bulk_claim_created: "Bulk claim created successfully",
    failed_create_bulk_claim: "Failed to create bulk claim. Please try again.",
    bulk_claim_updated: "Bulk claim updated successfully",
    failed_update_bulk_claim: "Failed to update claim. Please try again.",
    panel_info_missing: "Panel information is missing. Please try again.",
    no_invoices_found: "No invoices found for the selected items. Please check and try again.",
    copy_successful: "Copy successful",
    payment_added: "Payment added successfully.",
    payment_updated: "Payment updated successfully.",
    failed_save_payment: "Failed to save payment. Please try again.",
    fill_required_fields_payment: "Please fill in the required fields.",
    amount_greater_than_zero: "Amount must be greater than zero",
    filter_parameters_corrupted: "Filter parameters are corrupted. Filters have been cleared.",
    // Placeholders
    enter_amount: "Enter amount",
    payment_ref_placeholder: "FPX1234567890",
    write_payment_note_here: "Write payment note here",
    write_remarks_here: "Write remarks here",
    select_submitted_date: "Select submitted date",
    select_approved_date: "Select approved date",
    select_rejected_date: "Select rejected date",
    select_received_date: "Select received date",
    select_price_tiers: "Select price tiers",
    click_to_upload: "Click to upload",
    or_drag_and_drop: "or drag and drop",
    jpg_png_max_5mb: "JPG and PNG (max. 5MB)",
    // Descriptions
    invoice_details_description: "Below are the details of the selected invoice.",
    selected_invoices_description: "Review the invoices included in this panel claim before proceeding.",
    panel_claim_details_description: "Key information related to the submitted panel claim.",
    review_invoices_before_proceeding: "Review the invoices included in this panel claim before proceeding.",
    review_invoices_bulk_claim: "Review the invoices included in this bulk claim.",
    key_information_submitted_claim: "Key information that will be submitted with this claim.",
    scan_qr_upload_description: "Scan the QR code to upload files from other devices.",
    // Badges and status
    panel_badge: "Panel",
    multiple_patients: "Multiple patients",
    multiple_panels: "Multiple Panels",
    // Empty states
    no_document_added: "No document added",
    added_document_will_show_here: "Added document will be shown here",
    no_payment_added: "No payment added",
    added_payment_will_show_here: "Added payment will be shown here",
    no_document_selected: "No document selected",
    select_files_left_pane: "Select files on the left pane to view details",
    preview_not_available: "Preview not available",
    no_eligible_staff_found: "No eligible staff found",
    eligible_staff_will_appear_here: "Staff members eligible for this panel will appear here",
    no_visits_recorded: "No visits recorded",
    visits_will_appear_here: "Any past and current panel visits will appear here",
    no_treatment_items_found: "No treatment items found",
    unable_to_load_claim_details: "Unable to load claim details",
    check_claim_rid_and_retry: "The claim information could not be retrieved. Please check the claim RID and try again.",
    unable_to_load_invoices: "Unable to load invoices",
    check_and_retry: "The invoice information could not be retrieved. Please check and try again.",
    unable_to_load_invoice_details: "Unable to load invoice details",
    check_invoice_id_and_retry: "The invoice information could not be retrieved. Please check the invoice ID and try again.",
    invoice_info_could_not_be_retrieved: "The invoice information could not be retrieved. Please try again.",
    // Date ranges
    all_time: "All time",
    yesterday: "Yesterday",
    last_90_days: "Last 90 days",
    this_week: "This week",
    this_year: "This year",
    last_week: "Last week",
    custom: "Custom",
    // Other
    files: "files",
    invoice: "invoice",
    invoices: "invoices",
    items: "items",
    loading_pdf: "Loading PDF...",
    selected: "Selected",
    submit: "Submit",
    submit_daily: "Submit daily by",
    submit_weekly: "Submit weekly by",
    submit_monthly: "Submit monthly by",
    same_day: "Same day",
    next_day: "Next day",
    days_after_2: "2 days after",
    days_after_3: "3 days after",
    payment_details: "Payment Details:",
    method: "Method:",
    notes: "Notes:",
    reference_no: "Reference No:",
    // Validation
    payment_method_required: "Payment method is required",
    amount_required: "Amount is required",
    payment_type_required: "Payment type is required",
    date_required: "Date is required",
    please_select_at_least_one_price_tier: "Please select at least one price tier",
    // Actions and UI elements
    view: "View",
    logs: "Logs",
    add_note: "Add note",
    add_more: "Add more",
    // Error states
    unable_to_load_logs: "Unable to load logs",
    log_info_could_not_be_retrieved: "The log information could not be retrieved. Please try again.",
    try_again: "Try again",
    // Success messages
    note_deleted_successfully: "Note deleted successfully",
    download_started: "Download started",
    // Additional UI translations
    payment_summary: "Payment summary",
    assigned: "Assigned",
    assign_balance: "Assign balance",
    select_at_least_2_invoices: "Select at least 2 invoices",
    all_invoices_same_panel: "All selected invoices must be from the same panel",
    update_claim_status: "Update panel claim status",
    mark_all_as_approved: "Mark all as approved",
    mark_all_as_rejected: "Mark all as rejected",
    mark_all_as_received: "Mark all as received",
    changing_to_single_view: "Changing to single panel claim view",
    please_wait_updating_view: "Please wait while we update the view...",
    staff_identification_list: "List of staff identification",
    staff_identification_description: "Record patient's staff identification number upon registration.",
    panel_required: "Panel is required",
    staff_id_required: "Staff ID is required",
    select_panel: "Select a panel",
    please_select_panel: "Please select panel",
    // Single claim summary card (only non-duplicate keys)
    summary: "Summary",
    billed_to: "Billed to",
    panel_claim_number: "Panel claim number",
    id: "ID",
    panel_claim_submission_due_date: "Panel claim submission due date",
    received_date: "Received date",
    invoice_items: "Invoice items",
    invoice_total: "Invoice total",
    no_claim_associated: "No claim associated",
    created_date: "Created date",
    select_date: "Select date",
  },
  registration_page: {
    registration_form: {
      self: "Self",
      dependent: "Dependent",
    },
    cancel_visit: {
      title: "Confirm cancel visit",
      warning_message: "Cancelling this visit will also cancel the linked invoice and claim.",
      subtitle: "This action will be done immediately and cannot be undone. Click \"Confirm\" to proceed.",
      linked_documents: "Linked documents:",
      invoice_number: "Invoice number",
      panel_claim_number: "Panel claim number",
      claim: "Claim details",
      claim_amount: "Claimed amount",
      current_claimed_amount: "Current claimed amount",
      new_claim_amount: "New claim amount",
      total_adjustments: "Total adjustments",
      visit_cancelled_successfully: "Visit cancelled successfully",
      restriction_title: "Cancel visit restriction",
      restriction_not_allowed: "Cancellation for this visit is not allowed.",
      restriction_approved_received: "Visit cancellation is restricted because the invoice is linked to a claim with {status} status.",
      restriction_multiple_claims: "Visit cancellation is restricted because the invoice is linked to multiple claims.",
      close: "Close"
    }
  }
}